/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as R401RouteImport } from './routes/401';
import { Route as R403RouteImport } from './routes/403';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as LoginRouteImport } from './routes/login';
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated/$';
import { Route as AuthenticatedCategoriesRouteRouteImport } from './routes/_authenticated/categories/route';
import { Route as AuthenticatedCollectionsRouteRouteImport } from './routes/_authenticated/collections/route';
import { Route as AuthenticatedGeneeaEntitiesRouteRouteImport } from './routes/_authenticated/geneea-entities/route';
import { Route as AuthenticatedKickwordsRouteRouteImport } from './routes/_authenticated/kickwords/route';
import { Route as AuthenticatedNewslettersRouteRouteImport } from './routes/_authenticated/newsletters/route';
import { Route as AuthenticatedPlacementRouteRouteImport } from './routes/_authenticated/placement/route';
import { Route as AuthenticatedReleasenotesRouteRouteImport } from './routes/_authenticated/releasenotes/route';
import { Route as AuthenticatedRtelementsRouteRouteImport } from './routes/_authenticated/rtelements/route';
import { Route as AuthenticatedSitemapsRouteRouteImport } from './routes/_authenticated/sitemaps/route';
import { Route as AuthenticatedTagsRouteRouteImport } from './routes/_authenticated/tags/route';
import { Route as AuthenticatedTeamsRouteRouteImport } from './routes/_authenticated/teams/route';
import { Route as AuthenticatedUsersRouteRouteImport } from './routes/_authenticated/users/route';
import { Route as AuthenticatedhomeIndexRouteImport } from './routes/_authenticated/(home)/index';
import { Route as AuthenticatedArticlesIndexRouteImport } from './routes/_authenticated/articles/index';
import { Route as AuthenticatedArticlesIdRouteRouteImport } from './routes/_authenticated/articles/$id/route';
import { Route as AuthenticatedArticlesNewRouteImport } from './routes/_authenticated/articles/new';
import { Route as AuthenticatedBreakingnewsIndexRouteImport } from './routes/_authenticated/breakingnews/index';
import { Route as AuthenticatedBreakingnewsIdRouteRouteImport } from './routes/_authenticated/breakingnews/$id/route';
import { Route as AuthenticatedBreakingnewsNewRouteImport } from './routes/_authenticated/breakingnews/new';
import { Route as AuthenticatedCategoriesIndexRouteImport } from './routes/_authenticated/categories/index';
import { Route as AuthenticatedCategoriesIdRouteImport } from './routes/_authenticated/categories/$id';
import { Route as AuthenticatedCategoriesNewRouteImport } from './routes/_authenticated/categories/new';
import { Route as AuthenticatedCollectionsIndexRouteImport } from './routes/_authenticated/collections/index';
import { Route as AuthenticatedCollectionsCollectionIdRouteImport } from './routes/_authenticated/collections/$collectionId';
import { Route as AuthenticatedCuratedListIndexRouteImport } from './routes/_authenticated/curatedList/index';
import { Route as AuthenticatedGeneeaEntitiesIndexRouteImport } from './routes/_authenticated/geneea-entities/index';
import { Route as AuthenticatedGeneeaEntitiesIdRouteImport } from './routes/_authenticated/geneea-entities/$id';
import { Route as AuthenticatedKickwordsIndexRouteImport } from './routes/_authenticated/kickwords/index';
import { Route as AuthenticatedKickwordsIdRouteImport } from './routes/_authenticated/kickwords/$id';
import { Route as AuthenticatedKickwordsNewRouteImport } from './routes/_authenticated/kickwords/new';
import { Route as AuthenticatedMaintenancenotesIdRouteImport } from './routes/_authenticated/maintenancenotes/$id';
import { Route as AuthenticatedNewslettersIndexRouteImport } from './routes/_authenticated/newsletters/index';
import { Route as AuthenticatedNewslettersIdRouteImport } from './routes/_authenticated/newsletters/$id';
import { Route as AuthenticatedPlacementIndexRouteImport } from './routes/_authenticated/placement/index';
import { Route as AuthenticatedPlateIndexRouteImport } from './routes/_authenticated/plate/index';
import { Route as AuthenticatedReleasenotesIndexRouteImport } from './routes/_authenticated/releasenotes/index';
import { Route as AuthenticatedReleasenotesIdRouteImport } from './routes/_authenticated/releasenotes/$id';
import { Route as AuthenticatedReleasenotesNewRouteImport } from './routes/_authenticated/releasenotes/new';
import { Route as AuthenticatedRtelementsIndexRouteImport } from './routes/_authenticated/rtelements/index';
import { Route as AuthenticatedRtelementsElementIdRouteImport } from './routes/_authenticated/rtelements/$elementId';
import { Route as AuthenticatedRtelementsNewRouteImport } from './routes/_authenticated/rtelements/new';
import { Route as AuthenticatedSitemapsIndexRouteImport } from './routes/_authenticated/sitemaps/index';
import { Route as AuthenticatedSitemapsTenantIdRouteRouteImport } from './routes/_authenticated/sitemaps/$tenantId/route';
import { Route as AuthenticatedSlideshowsIndexRouteImport } from './routes/_authenticated/slideshows/index';
import { Route as AuthenticatedSlideshowsIdRouteRouteImport } from './routes/_authenticated/slideshows/$id/route';
import { Route as AuthenticatedSlideshowsNewRouteImport } from './routes/_authenticated/slideshows/new';
import { Route as AuthenticatedTagsIndexRouteImport } from './routes/_authenticated/tags/index';
import { Route as AuthenticatedTagsIdRouteImport } from './routes/_authenticated/tags/$id';
import { Route as AuthenticatedTagsNewRouteImport } from './routes/_authenticated/tags/new';
import { Route as AuthenticatedTeamsIndexRouteImport } from './routes/_authenticated/teams/index';
import { Route as AuthenticatedTeamsIceHockeyTeamsRouteRouteImport } from './routes/_authenticated/teams/iceHockeyTeams/route';
import { Route as AuthenticatedTeamsLeaguesAndTournamentsRouteRouteImport } from './routes/_authenticated/teams/leaguesAndTournaments/route';
import { Route as AuthenticatedTeamsSoccerTeamsRouteRouteImport } from './routes/_authenticated/teams/soccerTeams/route';
import { Route as AuthenticatedTeamsTennisPlayersRouteRouteImport } from './routes/_authenticated/teams/tennisPlayers/route';
import { Route as AuthenticatedTickersIndexRouteImport } from './routes/_authenticated/tickers/index';
import { Route as AuthenticatedTickersIdRouteRouteImport } from './routes/_authenticated/tickers/$id/route';
import { Route as AuthenticatedTickersNewRouteImport } from './routes/_authenticated/tickers/new';
import { Route as AuthenticatedUserSettingsIndexRouteImport } from './routes/_authenticated/userSettings/index';
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index';
import { Route as AuthenticatedUsersIdRouteImport } from './routes/_authenticated/users/$id';
import { Route as AuthenticatedUsersNewRouteImport } from './routes/_authenticated/users/new';
import { Route as AuthenticatedArticlesIdIndexRouteImport } from './routes/_authenticated/articles/$id/index';
import { Route as AuthenticatedArticlesIdMetadataRouteImport } from './routes/_authenticated/articles/$id/metadata';
import { Route as AuthenticatedArticlesIdPushRouteImport } from './routes/_authenticated/articles/$id/push';
import { Route as AuthenticatedBreakingnewsIdIndexRouteImport } from './routes/_authenticated/breakingnews/$id/index';
import { Route as AuthenticatedBreakingnewsIdMetadataRouteImport } from './routes/_authenticated/breakingnews/$id/metadata';
import { Route as AuthenticatedBreakingnewsIdPushRouteImport } from './routes/_authenticated/breakingnews/$id/push';
import { Route as AuthenticatedExternalContentEmbedsIndexRouteImport } from './routes/_authenticated/externalContent/embeds/index';
import { Route as AuthenticatedExternalContentEmbedsIdRouteRouteImport } from './routes/_authenticated/externalContent/embeds/$id/route';
import { Route as AuthenticatedExternalContentEmbedsNewRouteImport } from './routes/_authenticated/externalContent/embeds/new';
import { Route as AuthenticatedExternalContentLinksIndexRouteImport } from './routes/_authenticated/externalContent/links/index';
import { Route as AuthenticatedExternalContentLinksIdRouteRouteImport } from './routes/_authenticated/externalContent/links/$id/route';
import { Route as AuthenticatedExternalContentLinksNewRouteImport } from './routes/_authenticated/externalContent/links/new';
import { Route as AuthenticatedExternalContentVideosIndexRouteImport } from './routes/_authenticated/externalContent/videos/index';
import { Route as AuthenticatedExternalContentVideosIdRouteRouteImport } from './routes/_authenticated/externalContent/videos/$id/route';
import { Route as AuthenticatedExternalContentVideosNewRouteImport } from './routes/_authenticated/externalContent/videos/new';
import { Route as AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125RouteImport } from './routes/_authenticated/isolated/{-$scenarioName}/{-$preset}';
import { Route as AuthenticatedPlacementHistoryMetadataIdRouteImport } from './routes/_authenticated/placement/history/$metadataId';
import { Route as AuthenticatedSitemapsTenantIdIndexRouteImport } from './routes/_authenticated/sitemaps/$tenantId/index';
import { Route as AuthenticatedSlideshowsIdContentRouteImport } from './routes/_authenticated/slideshows/$id/_content';
import { Route as AuthenticatedSlideshowsIdMetadataRouteImport } from './routes/_authenticated/slideshows/$id/metadata';
import { Route as AuthenticatedSlideshowsIdPushRouteImport } from './routes/_authenticated/slideshows/$id/push';
import { Route as AuthenticatedTeamsIceHockeyTeamsIndexRouteImport } from './routes/_authenticated/teams/iceHockeyTeams/index';
import { Route as AuthenticatedTeamsIceHockeyTeamsIdRouteImport } from './routes/_authenticated/teams/iceHockeyTeams/$id';
import { Route as AuthenticatedTeamsIceHockeyTeamsNewRouteImport } from './routes/_authenticated/teams/iceHockeyTeams/new';
import { Route as AuthenticatedTeamsLeaguesAndTournamentsIndexRouteImport } from './routes/_authenticated/teams/leaguesAndTournaments/index';
import { Route as AuthenticatedTeamsLeaguesAndTournamentsIdRouteImport } from './routes/_authenticated/teams/leaguesAndTournaments/$id';
import { Route as AuthenticatedTeamsLeaguesAndTournamentsNewRouteImport } from './routes/_authenticated/teams/leaguesAndTournaments/new';
import { Route as AuthenticatedTeamsSoccerTeamsIndexRouteImport } from './routes/_authenticated/teams/soccerTeams/index';
import { Route as AuthenticatedTeamsSoccerTeamsIdRouteImport } from './routes/_authenticated/teams/soccerTeams/$id';
import { Route as AuthenticatedTeamsSoccerTeamsNewRouteImport } from './routes/_authenticated/teams/soccerTeams/new';
import { Route as AuthenticatedTeamsTennisPlayersIndexRouteImport } from './routes/_authenticated/teams/tennisPlayers/index';
import { Route as AuthenticatedTeamsTennisPlayersIdRouteImport } from './routes/_authenticated/teams/tennisPlayers/$id';
import { Route as AuthenticatedTeamsTennisPlayersNewRouteImport } from './routes/_authenticated/teams/tennisPlayers/new';
import { Route as AuthenticatedTickersIdIndexRouteImport } from './routes/_authenticated/tickers/$id/index';
import { Route as AuthenticatedTickersIdMetadataRouteImport } from './routes/_authenticated/tickers/$id/metadata';
import { Route as AuthenticatedTickersIdPushRouteImport } from './routes/_authenticated/tickers/$id/push';
import { Route as AuthenticatedArticlesIdRevisionsRevisionIdRouteImport } from './routes/_authenticated/articles/$id/revisions/$revisionId';
import { Route as AuthenticatedExternalContentEmbedsIdIndexRouteImport } from './routes/_authenticated/externalContent/embeds/$id/index';
import { Route as AuthenticatedExternalContentEmbedsIdMetadataRouteImport } from './routes/_authenticated/externalContent/embeds/$id/metadata';
import { Route as AuthenticatedExternalContentEmbedsIdPushRouteImport } from './routes/_authenticated/externalContent/embeds/$id/push';
import { Route as AuthenticatedExternalContentLinksIdIndexRouteImport } from './routes/_authenticated/externalContent/links/$id/index';
import { Route as AuthenticatedExternalContentLinksIdMetadataRouteImport } from './routes/_authenticated/externalContent/links/$id/metadata';
import { Route as AuthenticatedExternalContentLinksIdPushRouteImport } from './routes/_authenticated/externalContent/links/$id/push';
import { Route as AuthenticatedExternalContentVideosIdIndexRouteImport } from './routes/_authenticated/externalContent/videos/$id/index';
import { Route as AuthenticatedExternalContentVideosIdMetadataRouteImport } from './routes/_authenticated/externalContent/videos/$id/metadata';
import { Route as AuthenticatedExternalContentVideosIdPushRouteImport } from './routes/_authenticated/externalContent/videos/$id/push';
import { Route as AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125RouteImport } from './routes/_authenticated/preview/metadata/$metadataId/{-$tenantId}';
import { Route as AuthenticatedPreviewPlacementSectionIdTenantIdRouteImport } from './routes/_authenticated/preview/placement/$sectionId/$tenantId';
import { Route as AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRouteImport } from './routes/_authenticated/sitemaps/$tenantId/nodes/$sitemapNodeId';
import { Route as AuthenticatedSitemapsTenantIdNodesNewRouteImport } from './routes/_authenticated/sitemaps/$tenantId/nodes/new';
import { Route as AuthenticatedSlideshowsIdContentIndexRouteImport } from './routes/_authenticated/slideshows/$id/_content/index';
import { Route as AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteImport } from './routes/_authenticated/placement/$tenantId/category/$categoryId/sections/route';
import { Route as AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteImport } from './routes/_authenticated/placement/$tenantId/tag/$tagId/sections/route';
import { Route as AuthenticatedSlideshowsIdContentSlidesSlideIdRouteImport } from './routes/_authenticated/slideshows/$id/_content/slides/$slideId';
import { Route as AuthenticatedSlideshowsIdContentSlidesBulkRouteImport } from './routes/_authenticated/slideshows/$id/_content/slides/bulk';
import { Route as AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRouteImport } from './routes/_authenticated/placement/$tenantId/category/$categoryId/sections/$sectionId';
import { Route as AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRouteImport } from './routes/_authenticated/placement/$tenantId/category/$categoryId/sections/new';
import { Route as AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRouteImport } from './routes/_authenticated/placement/$tenantId/tag/$tagId/sections/$sectionId';
import { Route as AuthenticatedPlacementTenantIdTagTagIdSectionsNewRouteImport } from './routes/_authenticated/placement/$tenantId/tag/$tagId/sections/new';

const R401Route = R401RouteImport.update({
  id: '/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any);
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedCategoriesRouteRoute =
  AuthenticatedCategoriesRouteRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedCollectionsRouteRoute =
  AuthenticatedCollectionsRouteRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedGeneeaEntitiesRouteRoute =
  AuthenticatedGeneeaEntitiesRouteRouteImport.update({
    id: '/geneea-entities',
    path: '/geneea-entities',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedKickwordsRouteRoute =
  AuthenticatedKickwordsRouteRouteImport.update({
    id: '/kickwords',
    path: '/kickwords',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedNewslettersRouteRoute =
  AuthenticatedNewslettersRouteRouteImport.update({
    id: '/newsletters',
    path: '/newsletters',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlacementRouteRoute =
  AuthenticatedPlacementRouteRouteImport.update({
    id: '/placement',
    path: '/placement',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedReleasenotesRouteRoute =
  AuthenticatedReleasenotesRouteRouteImport.update({
    id: '/releasenotes',
    path: '/releasenotes',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedRtelementsRouteRoute =
  AuthenticatedRtelementsRouteRouteImport.update({
    id: '/rtelements',
    path: '/rtelements',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSitemapsRouteRoute =
  AuthenticatedSitemapsRouteRouteImport.update({
    id: '/sitemaps',
    path: '/sitemaps',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTagsRouteRoute = AuthenticatedTagsRouteRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedTeamsRouteRoute = AuthenticatedTeamsRouteRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedUsersRouteRoute = AuthenticatedUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedhomeIndexRoute = AuthenticatedhomeIndexRouteImport.update({
  id: '/(home)/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedArticlesIndexRoute =
  AuthenticatedArticlesIndexRouteImport.update({
    id: '/articles/',
    path: '/articles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedArticlesIdRouteRoute =
  AuthenticatedArticlesIdRouteRouteImport.update({
    id: '/articles/$id',
    path: '/articles/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedArticlesNewRoute =
  AuthenticatedArticlesNewRouteImport.update({
    id: '/articles/new',
    path: '/articles/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedBreakingnewsIndexRoute =
  AuthenticatedBreakingnewsIndexRouteImport.update({
    id: '/breakingnews/',
    path: '/breakingnews/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedBreakingnewsIdRouteRoute =
  AuthenticatedBreakingnewsIdRouteRouteImport.update({
    id: '/breakingnews/$id',
    path: '/breakingnews/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedBreakingnewsNewRoute =
  AuthenticatedBreakingnewsNewRouteImport.update({
    id: '/breakingnews/new',
    path: '/breakingnews/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedCategoriesIndexRoute =
  AuthenticatedCategoriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCategoriesRouteRoute,
  } as any);
const AuthenticatedCategoriesIdRoute =
  AuthenticatedCategoriesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedCategoriesRouteRoute,
  } as any);
const AuthenticatedCategoriesNewRoute =
  AuthenticatedCategoriesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedCategoriesRouteRoute,
  } as any);
const AuthenticatedCollectionsIndexRoute =
  AuthenticatedCollectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCollectionsRouteRoute,
  } as any);
const AuthenticatedCollectionsCollectionIdRoute =
  AuthenticatedCollectionsCollectionIdRouteImport.update({
    id: '/$collectionId',
    path: '/$collectionId',
    getParentRoute: () => AuthenticatedCollectionsRouteRoute,
  } as any);
const AuthenticatedCuratedListIndexRoute =
  AuthenticatedCuratedListIndexRouteImport.update({
    id: '/curatedList/',
    path: '/curatedList/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedGeneeaEntitiesIndexRoute =
  AuthenticatedGeneeaEntitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGeneeaEntitiesRouteRoute,
  } as any);
const AuthenticatedGeneeaEntitiesIdRoute =
  AuthenticatedGeneeaEntitiesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedGeneeaEntitiesRouteRoute,
  } as any);
const AuthenticatedKickwordsIndexRoute =
  AuthenticatedKickwordsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedKickwordsRouteRoute,
  } as any);
const AuthenticatedKickwordsIdRoute =
  AuthenticatedKickwordsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedKickwordsRouteRoute,
  } as any);
const AuthenticatedKickwordsNewRoute =
  AuthenticatedKickwordsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedKickwordsRouteRoute,
  } as any);
const AuthenticatedMaintenancenotesIdRoute =
  AuthenticatedMaintenancenotesIdRouteImport.update({
    id: '/maintenancenotes/$id',
    path: '/maintenancenotes/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedNewslettersIndexRoute =
  AuthenticatedNewslettersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNewslettersRouteRoute,
  } as any);
const AuthenticatedNewslettersIdRoute =
  AuthenticatedNewslettersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedNewslettersRouteRoute,
  } as any);
const AuthenticatedPlacementIndexRoute =
  AuthenticatedPlacementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPlacementRouteRoute,
  } as any);
const AuthenticatedPlateIndexRoute = AuthenticatedPlateIndexRouteImport.update({
  id: '/plate/',
  path: '/plate/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedReleasenotesIndexRoute =
  AuthenticatedReleasenotesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReleasenotesRouteRoute,
  } as any);
const AuthenticatedReleasenotesIdRoute =
  AuthenticatedReleasenotesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedReleasenotesRouteRoute,
  } as any);
const AuthenticatedReleasenotesNewRoute =
  AuthenticatedReleasenotesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedReleasenotesRouteRoute,
  } as any);
const AuthenticatedRtelementsIndexRoute =
  AuthenticatedRtelementsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedRtelementsRouteRoute,
  } as any);
const AuthenticatedRtelementsElementIdRoute =
  AuthenticatedRtelementsElementIdRouteImport.update({
    id: '/$elementId',
    path: '/$elementId',
    getParentRoute: () => AuthenticatedRtelementsRouteRoute,
  } as any);
const AuthenticatedRtelementsNewRoute =
  AuthenticatedRtelementsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedRtelementsRouteRoute,
  } as any);
const AuthenticatedSitemapsIndexRoute =
  AuthenticatedSitemapsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSitemapsRouteRoute,
  } as any);
const AuthenticatedSitemapsTenantIdRouteRoute =
  AuthenticatedSitemapsTenantIdRouteRouteImport.update({
    id: '/$tenantId',
    path: '/$tenantId',
    getParentRoute: () => AuthenticatedSitemapsRouteRoute,
  } as any);
const AuthenticatedSlideshowsIndexRoute =
  AuthenticatedSlideshowsIndexRouteImport.update({
    id: '/slideshows/',
    path: '/slideshows/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSlideshowsIdRouteRoute =
  AuthenticatedSlideshowsIdRouteRouteImport.update({
    id: '/slideshows/$id',
    path: '/slideshows/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSlideshowsNewRoute =
  AuthenticatedSlideshowsNewRouteImport.update({
    id: '/slideshows/new',
    path: '/slideshows/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTagsIndexRoute = AuthenticatedTagsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedTagsRouteRoute,
} as any);
const AuthenticatedTagsIdRoute = AuthenticatedTagsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedTagsRouteRoute,
} as any);
const AuthenticatedTagsNewRoute = AuthenticatedTagsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedTagsRouteRoute,
} as any);
const AuthenticatedTeamsIndexRoute = AuthenticatedTeamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedTeamsRouteRoute,
} as any);
const AuthenticatedTeamsIceHockeyTeamsRouteRoute =
  AuthenticatedTeamsIceHockeyTeamsRouteRouteImport.update({
    id: '/iceHockeyTeams',
    path: '/iceHockeyTeams',
    getParentRoute: () => AuthenticatedTeamsRouteRoute,
  } as any);
const AuthenticatedTeamsLeaguesAndTournamentsRouteRoute =
  AuthenticatedTeamsLeaguesAndTournamentsRouteRouteImport.update({
    id: '/leaguesAndTournaments',
    path: '/leaguesAndTournaments',
    getParentRoute: () => AuthenticatedTeamsRouteRoute,
  } as any);
const AuthenticatedTeamsSoccerTeamsRouteRoute =
  AuthenticatedTeamsSoccerTeamsRouteRouteImport.update({
    id: '/soccerTeams',
    path: '/soccerTeams',
    getParentRoute: () => AuthenticatedTeamsRouteRoute,
  } as any);
const AuthenticatedTeamsTennisPlayersRouteRoute =
  AuthenticatedTeamsTennisPlayersRouteRouteImport.update({
    id: '/tennisPlayers',
    path: '/tennisPlayers',
    getParentRoute: () => AuthenticatedTeamsRouteRoute,
  } as any);
const AuthenticatedTickersIndexRoute =
  AuthenticatedTickersIndexRouteImport.update({
    id: '/tickers/',
    path: '/tickers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTickersIdRouteRoute =
  AuthenticatedTickersIdRouteRouteImport.update({
    id: '/tickers/$id',
    path: '/tickers/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTickersNewRoute = AuthenticatedTickersNewRouteImport.update({
  id: '/tickers/new',
  path: '/tickers/new',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedUserSettingsIndexRoute =
  AuthenticatedUserSettingsIndexRouteImport.update({
    id: '/userSettings/',
    path: '/userSettings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any);
const AuthenticatedUsersIdRoute = AuthenticatedUsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any);
const AuthenticatedUsersNewRoute = AuthenticatedUsersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any);
const AuthenticatedArticlesIdIndexRoute =
  AuthenticatedArticlesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedArticlesIdRouteRoute,
  } as any);
const AuthenticatedArticlesIdMetadataRoute =
  AuthenticatedArticlesIdMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedArticlesIdRouteRoute,
  } as any);
const AuthenticatedArticlesIdPushRoute =
  AuthenticatedArticlesIdPushRouteImport.update({
    id: '/push',
    path: '/push',
    getParentRoute: () => AuthenticatedArticlesIdRouteRoute,
  } as any);
const AuthenticatedBreakingnewsIdIndexRoute =
  AuthenticatedBreakingnewsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBreakingnewsIdRouteRoute,
  } as any);
const AuthenticatedBreakingnewsIdMetadataRoute =
  AuthenticatedBreakingnewsIdMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedBreakingnewsIdRouteRoute,
  } as any);
const AuthenticatedBreakingnewsIdPushRoute =
  AuthenticatedBreakingnewsIdPushRouteImport.update({
    id: '/push',
    path: '/push',
    getParentRoute: () => AuthenticatedBreakingnewsIdRouteRoute,
  } as any);
const AuthenticatedExternalContentEmbedsIndexRoute =
  AuthenticatedExternalContentEmbedsIndexRouteImport.update({
    id: '/externalContent/embeds/',
    path: '/externalContent/embeds/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedExternalContentEmbedsIdRouteRoute =
  AuthenticatedExternalContentEmbedsIdRouteRouteImport.update({
    id: '/externalContent/embeds/$id',
    path: '/externalContent/embeds/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedExternalContentEmbedsNewRoute =
  AuthenticatedExternalContentEmbedsNewRouteImport.update({
    id: '/externalContent/embeds/new',
    path: '/externalContent/embeds/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedExternalContentLinksIndexRoute =
  AuthenticatedExternalContentLinksIndexRouteImport.update({
    id: '/externalContent/links/',
    path: '/externalContent/links/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedExternalContentLinksIdRouteRoute =
  AuthenticatedExternalContentLinksIdRouteRouteImport.update({
    id: '/externalContent/links/$id',
    path: '/externalContent/links/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedExternalContentLinksNewRoute =
  AuthenticatedExternalContentLinksNewRouteImport.update({
    id: '/externalContent/links/new',
    path: '/externalContent/links/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedExternalContentVideosIndexRoute =
  AuthenticatedExternalContentVideosIndexRouteImport.update({
    id: '/externalContent/videos/',
    path: '/externalContent/videos/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedExternalContentVideosIdRouteRoute =
  AuthenticatedExternalContentVideosIdRouteRouteImport.update({
    id: '/externalContent/videos/$id',
    path: '/externalContent/videos/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedExternalContentVideosNewRoute =
  AuthenticatedExternalContentVideosNewRouteImport.update({
    id: '/externalContent/videos/new',
    path: '/externalContent/videos/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125Route =
  AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125RouteImport.update(
    {
      id: '/isolated/{-$scenarioName}/{-$preset}',
      path: '/isolated/{-$scenarioName}/{-$preset}',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  );
const AuthenticatedPlacementHistoryMetadataIdRoute =
  AuthenticatedPlacementHistoryMetadataIdRouteImport.update({
    id: '/history/$metadataId',
    path: '/history/$metadataId',
    getParentRoute: () => AuthenticatedPlacementRouteRoute,
  } as any);
const AuthenticatedSitemapsTenantIdIndexRoute =
  AuthenticatedSitemapsTenantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSitemapsTenantIdRouteRoute,
  } as any);
const AuthenticatedSlideshowsIdContentRoute =
  AuthenticatedSlideshowsIdContentRouteImport.update({
    id: '/_content',
    getParentRoute: () => AuthenticatedSlideshowsIdRouteRoute,
  } as any);
const AuthenticatedSlideshowsIdMetadataRoute =
  AuthenticatedSlideshowsIdMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedSlideshowsIdRouteRoute,
  } as any);
const AuthenticatedSlideshowsIdPushRoute =
  AuthenticatedSlideshowsIdPushRouteImport.update({
    id: '/push',
    path: '/push',
    getParentRoute: () => AuthenticatedSlideshowsIdRouteRoute,
  } as any);
const AuthenticatedTeamsIceHockeyTeamsIndexRoute =
  AuthenticatedTeamsIceHockeyTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTeamsIceHockeyTeamsRouteRoute,
  } as any);
const AuthenticatedTeamsIceHockeyTeamsIdRoute =
  AuthenticatedTeamsIceHockeyTeamsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedTeamsIceHockeyTeamsRouteRoute,
  } as any);
const AuthenticatedTeamsIceHockeyTeamsNewRoute =
  AuthenticatedTeamsIceHockeyTeamsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedTeamsIceHockeyTeamsRouteRoute,
  } as any);
const AuthenticatedTeamsLeaguesAndTournamentsIndexRoute =
  AuthenticatedTeamsLeaguesAndTournamentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTeamsLeaguesAndTournamentsRouteRoute,
  } as any);
const AuthenticatedTeamsLeaguesAndTournamentsIdRoute =
  AuthenticatedTeamsLeaguesAndTournamentsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedTeamsLeaguesAndTournamentsRouteRoute,
  } as any);
const AuthenticatedTeamsLeaguesAndTournamentsNewRoute =
  AuthenticatedTeamsLeaguesAndTournamentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedTeamsLeaguesAndTournamentsRouteRoute,
  } as any);
const AuthenticatedTeamsSoccerTeamsIndexRoute =
  AuthenticatedTeamsSoccerTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTeamsSoccerTeamsRouteRoute,
  } as any);
const AuthenticatedTeamsSoccerTeamsIdRoute =
  AuthenticatedTeamsSoccerTeamsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedTeamsSoccerTeamsRouteRoute,
  } as any);
const AuthenticatedTeamsSoccerTeamsNewRoute =
  AuthenticatedTeamsSoccerTeamsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedTeamsSoccerTeamsRouteRoute,
  } as any);
const AuthenticatedTeamsTennisPlayersIndexRoute =
  AuthenticatedTeamsTennisPlayersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTeamsTennisPlayersRouteRoute,
  } as any);
const AuthenticatedTeamsTennisPlayersIdRoute =
  AuthenticatedTeamsTennisPlayersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedTeamsTennisPlayersRouteRoute,
  } as any);
const AuthenticatedTeamsTennisPlayersNewRoute =
  AuthenticatedTeamsTennisPlayersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedTeamsTennisPlayersRouteRoute,
  } as any);
const AuthenticatedTickersIdIndexRoute =
  AuthenticatedTickersIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTickersIdRouteRoute,
  } as any);
const AuthenticatedTickersIdMetadataRoute =
  AuthenticatedTickersIdMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedTickersIdRouteRoute,
  } as any);
const AuthenticatedTickersIdPushRoute =
  AuthenticatedTickersIdPushRouteImport.update({
    id: '/push',
    path: '/push',
    getParentRoute: () => AuthenticatedTickersIdRouteRoute,
  } as any);
const AuthenticatedArticlesIdRevisionsRevisionIdRoute =
  AuthenticatedArticlesIdRevisionsRevisionIdRouteImport.update({
    id: '/revisions/$revisionId',
    path: '/revisions/$revisionId',
    getParentRoute: () => AuthenticatedArticlesIdRouteRoute,
  } as any);
const AuthenticatedExternalContentEmbedsIdIndexRoute =
  AuthenticatedExternalContentEmbedsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedExternalContentEmbedsIdRouteRoute,
  } as any);
const AuthenticatedExternalContentEmbedsIdMetadataRoute =
  AuthenticatedExternalContentEmbedsIdMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedExternalContentEmbedsIdRouteRoute,
  } as any);
const AuthenticatedExternalContentEmbedsIdPushRoute =
  AuthenticatedExternalContentEmbedsIdPushRouteImport.update({
    id: '/push',
    path: '/push',
    getParentRoute: () => AuthenticatedExternalContentEmbedsIdRouteRoute,
  } as any);
const AuthenticatedExternalContentLinksIdIndexRoute =
  AuthenticatedExternalContentLinksIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedExternalContentLinksIdRouteRoute,
  } as any);
const AuthenticatedExternalContentLinksIdMetadataRoute =
  AuthenticatedExternalContentLinksIdMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedExternalContentLinksIdRouteRoute,
  } as any);
const AuthenticatedExternalContentLinksIdPushRoute =
  AuthenticatedExternalContentLinksIdPushRouteImport.update({
    id: '/push',
    path: '/push',
    getParentRoute: () => AuthenticatedExternalContentLinksIdRouteRoute,
  } as any);
const AuthenticatedExternalContentVideosIdIndexRoute =
  AuthenticatedExternalContentVideosIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedExternalContentVideosIdRouteRoute,
  } as any);
const AuthenticatedExternalContentVideosIdMetadataRoute =
  AuthenticatedExternalContentVideosIdMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedExternalContentVideosIdRouteRoute,
  } as any);
const AuthenticatedExternalContentVideosIdPushRoute =
  AuthenticatedExternalContentVideosIdPushRouteImport.update({
    id: '/push',
    path: '/push',
    getParentRoute: () => AuthenticatedExternalContentVideosIdRouteRoute,
  } as any);
const AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125Route =
  AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125RouteImport.update(
    {
      id: '/preview/metadata/$metadataId/{-$tenantId}',
      path: '/preview/metadata/$metadataId/{-$tenantId}',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  );
const AuthenticatedPreviewPlacementSectionIdTenantIdRoute =
  AuthenticatedPreviewPlacementSectionIdTenantIdRouteImport.update({
    id: '/preview/placement/$sectionId/$tenantId',
    path: '/preview/placement/$sectionId/$tenantId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRoute =
  AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRouteImport.update({
    id: '/nodes/$sitemapNodeId',
    path: '/nodes/$sitemapNodeId',
    getParentRoute: () => AuthenticatedSitemapsTenantIdRouteRoute,
  } as any);
const AuthenticatedSitemapsTenantIdNodesNewRoute =
  AuthenticatedSitemapsTenantIdNodesNewRouteImport.update({
    id: '/nodes/new',
    path: '/nodes/new',
    getParentRoute: () => AuthenticatedSitemapsTenantIdRouteRoute,
  } as any);
const AuthenticatedSlideshowsIdContentIndexRoute =
  AuthenticatedSlideshowsIdContentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSlideshowsIdContentRoute,
  } as any);
const AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRoute =
  AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteImport.update(
    {
      id: '/$tenantId/category/$categoryId/sections',
      path: '/$tenantId/category/$categoryId/sections',
      getParentRoute: () => AuthenticatedPlacementRouteRoute,
    } as any,
  );
const AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRoute =
  AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteImport.update({
    id: '/$tenantId/tag/$tagId/sections',
    path: '/$tenantId/tag/$tagId/sections',
    getParentRoute: () => AuthenticatedPlacementRouteRoute,
  } as any);
const AuthenticatedSlideshowsIdContentSlidesSlideIdRoute =
  AuthenticatedSlideshowsIdContentSlidesSlideIdRouteImport.update({
    id: '/slides/$slideId',
    path: '/slides/$slideId',
    getParentRoute: () => AuthenticatedSlideshowsIdContentRoute,
  } as any);
const AuthenticatedSlideshowsIdContentSlidesBulkRoute =
  AuthenticatedSlideshowsIdContentSlidesBulkRouteImport.update({
    id: '/slides/bulk',
    path: '/slides/bulk',
    getParentRoute: () => AuthenticatedSlideshowsIdContentRoute,
  } as any);
const AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRoute =
  AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRouteImport.update(
    {
      id: '/$sectionId',
      path: '/$sectionId',
      getParentRoute: () =>
        AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRoute,
    } as any,
  );
const AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRoute =
  AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRoute,
    } as any,
  );
const AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRoute =
  AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRouteImport.update({
    id: '/$sectionId',
    path: '/$sectionId',
    getParentRoute: () =>
      AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRoute,
  } as any);
const AuthenticatedPlacementTenantIdTagTagIdSectionsNewRoute =
  AuthenticatedPlacementTenantIdTagTagIdSectionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/401': typeof R401Route;
  '/403': typeof R403Route;
  '/': typeof AuthenticatedhomeIndexRoute;
  '/login': typeof LoginRoute;
  '/categories': typeof AuthenticatedCategoriesRouteRouteWithChildren;
  '/collections': typeof AuthenticatedCollectionsRouteRouteWithChildren;
  '/geneea-entities': typeof AuthenticatedGeneeaEntitiesRouteRouteWithChildren;
  '/kickwords': typeof AuthenticatedKickwordsRouteRouteWithChildren;
  '/newsletters': typeof AuthenticatedNewslettersRouteRouteWithChildren;
  '/placement': typeof AuthenticatedPlacementRouteRouteWithChildren;
  '/releasenotes': typeof AuthenticatedReleasenotesRouteRouteWithChildren;
  '/rtelements': typeof AuthenticatedRtelementsRouteRouteWithChildren;
  '/sitemaps': typeof AuthenticatedSitemapsRouteRouteWithChildren;
  '/tags': typeof AuthenticatedTagsRouteRouteWithChildren;
  '/teams': typeof AuthenticatedTeamsRouteRouteWithChildren;
  '/users': typeof AuthenticatedUsersRouteRouteWithChildren;
  '/$': typeof AuthenticatedSplatRoute;
  '/articles/$id': typeof AuthenticatedArticlesIdRouteRouteWithChildren;
  '/breakingnews/$id': typeof AuthenticatedBreakingnewsIdRouteRouteWithChildren;
  '/sitemaps/$tenantId': typeof AuthenticatedSitemapsTenantIdRouteRouteWithChildren;
  '/slideshows/$id': typeof AuthenticatedSlideshowsIdRouteRouteWithChildren;
  '/teams/iceHockeyTeams': typeof AuthenticatedTeamsIceHockeyTeamsRouteRouteWithChildren;
  '/teams/leaguesAndTournaments': typeof AuthenticatedTeamsLeaguesAndTournamentsRouteRouteWithChildren;
  '/teams/soccerTeams': typeof AuthenticatedTeamsSoccerTeamsRouteRouteWithChildren;
  '/teams/tennisPlayers': typeof AuthenticatedTeamsTennisPlayersRouteRouteWithChildren;
  '/tickers/$id': typeof AuthenticatedTickersIdRouteRouteWithChildren;
  '/articles/new': typeof AuthenticatedArticlesNewRoute;
  '/breakingnews/new': typeof AuthenticatedBreakingnewsNewRoute;
  '/categories/$id': typeof AuthenticatedCategoriesIdRoute;
  '/categories/new': typeof AuthenticatedCategoriesNewRoute;
  '/collections/$collectionId': typeof AuthenticatedCollectionsCollectionIdRoute;
  '/geneea-entities/$id': typeof AuthenticatedGeneeaEntitiesIdRoute;
  '/kickwords/$id': typeof AuthenticatedKickwordsIdRoute;
  '/kickwords/new': typeof AuthenticatedKickwordsNewRoute;
  '/maintenancenotes/$id': typeof AuthenticatedMaintenancenotesIdRoute;
  '/newsletters/$id': typeof AuthenticatedNewslettersIdRoute;
  '/releasenotes/$id': typeof AuthenticatedReleasenotesIdRoute;
  '/releasenotes/new': typeof AuthenticatedReleasenotesNewRoute;
  '/rtelements/$elementId': typeof AuthenticatedRtelementsElementIdRoute;
  '/rtelements/new': typeof AuthenticatedRtelementsNewRoute;
  '/slideshows/new': typeof AuthenticatedSlideshowsNewRoute;
  '/tags/$id': typeof AuthenticatedTagsIdRoute;
  '/tags/new': typeof AuthenticatedTagsNewRoute;
  '/tickers/new': typeof AuthenticatedTickersNewRoute;
  '/users/$id': typeof AuthenticatedUsersIdRoute;
  '/users/new': typeof AuthenticatedUsersNewRoute;
  '/articles/': typeof AuthenticatedArticlesIndexRoute;
  '/breakingnews/': typeof AuthenticatedBreakingnewsIndexRoute;
  '/categories/': typeof AuthenticatedCategoriesIndexRoute;
  '/collections/': typeof AuthenticatedCollectionsIndexRoute;
  '/curatedList/': typeof AuthenticatedCuratedListIndexRoute;
  '/geneea-entities/': typeof AuthenticatedGeneeaEntitiesIndexRoute;
  '/kickwords/': typeof AuthenticatedKickwordsIndexRoute;
  '/newsletters/': typeof AuthenticatedNewslettersIndexRoute;
  '/placement/': typeof AuthenticatedPlacementIndexRoute;
  '/plate/': typeof AuthenticatedPlateIndexRoute;
  '/releasenotes/': typeof AuthenticatedReleasenotesIndexRoute;
  '/rtelements/': typeof AuthenticatedRtelementsIndexRoute;
  '/sitemaps/': typeof AuthenticatedSitemapsIndexRoute;
  '/slideshows/': typeof AuthenticatedSlideshowsIndexRoute;
  '/tags/': typeof AuthenticatedTagsIndexRoute;
  '/teams/': typeof AuthenticatedTeamsIndexRoute;
  '/tickers/': typeof AuthenticatedTickersIndexRoute;
  '/userSettings/': typeof AuthenticatedUserSettingsIndexRoute;
  '/users/': typeof AuthenticatedUsersIndexRoute;
  '/externalContent/embeds/$id': typeof AuthenticatedExternalContentEmbedsIdRouteRouteWithChildren;
  '/externalContent/links/$id': typeof AuthenticatedExternalContentLinksIdRouteRouteWithChildren;
  '/externalContent/videos/$id': typeof AuthenticatedExternalContentVideosIdRouteRouteWithChildren;
  '/articles/$id/metadata': typeof AuthenticatedArticlesIdMetadataRoute;
  '/articles/$id/push': typeof AuthenticatedArticlesIdPushRoute;
  '/breakingnews/$id/metadata': typeof AuthenticatedBreakingnewsIdMetadataRoute;
  '/breakingnews/$id/push': typeof AuthenticatedBreakingnewsIdPushRoute;
  '/externalContent/embeds/new': typeof AuthenticatedExternalContentEmbedsNewRoute;
  '/externalContent/links/new': typeof AuthenticatedExternalContentLinksNewRoute;
  '/externalContent/videos/new': typeof AuthenticatedExternalContentVideosNewRoute;
  '/isolated/{-$scenarioName}/{-$preset}': typeof AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125Route;
  '/placement/history/$metadataId': typeof AuthenticatedPlacementHistoryMetadataIdRoute;
  '/slideshows/$id/metadata': typeof AuthenticatedSlideshowsIdMetadataRoute;
  '/slideshows/$id/push': typeof AuthenticatedSlideshowsIdPushRoute;
  '/teams/iceHockeyTeams/$id': typeof AuthenticatedTeamsIceHockeyTeamsIdRoute;
  '/teams/iceHockeyTeams/new': typeof AuthenticatedTeamsIceHockeyTeamsNewRoute;
  '/teams/leaguesAndTournaments/$id': typeof AuthenticatedTeamsLeaguesAndTournamentsIdRoute;
  '/teams/leaguesAndTournaments/new': typeof AuthenticatedTeamsLeaguesAndTournamentsNewRoute;
  '/teams/soccerTeams/$id': typeof AuthenticatedTeamsSoccerTeamsIdRoute;
  '/teams/soccerTeams/new': typeof AuthenticatedTeamsSoccerTeamsNewRoute;
  '/teams/tennisPlayers/$id': typeof AuthenticatedTeamsTennisPlayersIdRoute;
  '/teams/tennisPlayers/new': typeof AuthenticatedTeamsTennisPlayersNewRoute;
  '/tickers/$id/metadata': typeof AuthenticatedTickersIdMetadataRoute;
  '/tickers/$id/push': typeof AuthenticatedTickersIdPushRoute;
  '/articles/$id/': typeof AuthenticatedArticlesIdIndexRoute;
  '/breakingnews/$id/': typeof AuthenticatedBreakingnewsIdIndexRoute;
  '/externalContent/embeds/': typeof AuthenticatedExternalContentEmbedsIndexRoute;
  '/externalContent/links/': typeof AuthenticatedExternalContentLinksIndexRoute;
  '/externalContent/videos/': typeof AuthenticatedExternalContentVideosIndexRoute;
  '/sitemaps/$tenantId/': typeof AuthenticatedSitemapsTenantIdIndexRoute;
  '/teams/iceHockeyTeams/': typeof AuthenticatedTeamsIceHockeyTeamsIndexRoute;
  '/teams/leaguesAndTournaments/': typeof AuthenticatedTeamsLeaguesAndTournamentsIndexRoute;
  '/teams/soccerTeams/': typeof AuthenticatedTeamsSoccerTeamsIndexRoute;
  '/teams/tennisPlayers/': typeof AuthenticatedTeamsTennisPlayersIndexRoute;
  '/tickers/$id/': typeof AuthenticatedTickersIdIndexRoute;
  '/articles/$id/revisions/$revisionId': typeof AuthenticatedArticlesIdRevisionsRevisionIdRoute;
  '/externalContent/embeds/$id/metadata': typeof AuthenticatedExternalContentEmbedsIdMetadataRoute;
  '/externalContent/embeds/$id/push': typeof AuthenticatedExternalContentEmbedsIdPushRoute;
  '/externalContent/links/$id/metadata': typeof AuthenticatedExternalContentLinksIdMetadataRoute;
  '/externalContent/links/$id/push': typeof AuthenticatedExternalContentLinksIdPushRoute;
  '/externalContent/videos/$id/metadata': typeof AuthenticatedExternalContentVideosIdMetadataRoute;
  '/externalContent/videos/$id/push': typeof AuthenticatedExternalContentVideosIdPushRoute;
  '/preview/metadata/$metadataId/{-$tenantId}': typeof AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125Route;
  '/preview/placement/$sectionId/$tenantId': typeof AuthenticatedPreviewPlacementSectionIdTenantIdRoute;
  '/sitemaps/$tenantId/nodes/$sitemapNodeId': typeof AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRoute;
  '/sitemaps/$tenantId/nodes/new': typeof AuthenticatedSitemapsTenantIdNodesNewRoute;
  '/externalContent/embeds/$id/': typeof AuthenticatedExternalContentEmbedsIdIndexRoute;
  '/externalContent/links/$id/': typeof AuthenticatedExternalContentLinksIdIndexRoute;
  '/externalContent/videos/$id/': typeof AuthenticatedExternalContentVideosIdIndexRoute;
  '/slideshows/$id/': typeof AuthenticatedSlideshowsIdContentIndexRoute;
  '/placement/$tenantId/category/$categoryId/sections': typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteWithChildren;
  '/placement/$tenantId/tag/$tagId/sections': typeof AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteWithChildren;
  '/slideshows/$id/slides/$slideId': typeof AuthenticatedSlideshowsIdContentSlidesSlideIdRoute;
  '/slideshows/$id/slides/bulk': typeof AuthenticatedSlideshowsIdContentSlidesBulkRoute;
  '/placement/$tenantId/category/$categoryId/sections/$sectionId': typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRoute;
  '/placement/$tenantId/category/$categoryId/sections/new': typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRoute;
  '/placement/$tenantId/tag/$tagId/sections/$sectionId': typeof AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRoute;
  '/placement/$tenantId/tag/$tagId/sections/new': typeof AuthenticatedPlacementTenantIdTagTagIdSectionsNewRoute;
}
export interface FileRoutesByTo {
  '/401': typeof R401Route;
  '/403': typeof R403Route;
  '/login': typeof LoginRoute;
  '/$': typeof AuthenticatedSplatRoute;
  '/slideshows/$id': typeof AuthenticatedSlideshowsIdContentIndexRoute;
  '/articles/new': typeof AuthenticatedArticlesNewRoute;
  '/breakingnews/new': typeof AuthenticatedBreakingnewsNewRoute;
  '/categories/$id': typeof AuthenticatedCategoriesIdRoute;
  '/categories/new': typeof AuthenticatedCategoriesNewRoute;
  '/collections/$collectionId': typeof AuthenticatedCollectionsCollectionIdRoute;
  '/geneea-entities/$id': typeof AuthenticatedGeneeaEntitiesIdRoute;
  '/kickwords/$id': typeof AuthenticatedKickwordsIdRoute;
  '/kickwords/new': typeof AuthenticatedKickwordsNewRoute;
  '/maintenancenotes/$id': typeof AuthenticatedMaintenancenotesIdRoute;
  '/newsletters/$id': typeof AuthenticatedNewslettersIdRoute;
  '/releasenotes/$id': typeof AuthenticatedReleasenotesIdRoute;
  '/releasenotes/new': typeof AuthenticatedReleasenotesNewRoute;
  '/rtelements/$elementId': typeof AuthenticatedRtelementsElementIdRoute;
  '/rtelements/new': typeof AuthenticatedRtelementsNewRoute;
  '/slideshows/new': typeof AuthenticatedSlideshowsNewRoute;
  '/tags/$id': typeof AuthenticatedTagsIdRoute;
  '/tags/new': typeof AuthenticatedTagsNewRoute;
  '/tickers/new': typeof AuthenticatedTickersNewRoute;
  '/users/$id': typeof AuthenticatedUsersIdRoute;
  '/users/new': typeof AuthenticatedUsersNewRoute;
  '/': typeof AuthenticatedhomeIndexRoute;
  '/articles': typeof AuthenticatedArticlesIndexRoute;
  '/breakingnews': typeof AuthenticatedBreakingnewsIndexRoute;
  '/categories': typeof AuthenticatedCategoriesIndexRoute;
  '/collections': typeof AuthenticatedCollectionsIndexRoute;
  '/curatedList': typeof AuthenticatedCuratedListIndexRoute;
  '/geneea-entities': typeof AuthenticatedGeneeaEntitiesIndexRoute;
  '/kickwords': typeof AuthenticatedKickwordsIndexRoute;
  '/newsletters': typeof AuthenticatedNewslettersIndexRoute;
  '/placement': typeof AuthenticatedPlacementIndexRoute;
  '/plate': typeof AuthenticatedPlateIndexRoute;
  '/releasenotes': typeof AuthenticatedReleasenotesIndexRoute;
  '/rtelements': typeof AuthenticatedRtelementsIndexRoute;
  '/sitemaps': typeof AuthenticatedSitemapsIndexRoute;
  '/slideshows': typeof AuthenticatedSlideshowsIndexRoute;
  '/tags': typeof AuthenticatedTagsIndexRoute;
  '/teams': typeof AuthenticatedTeamsIndexRoute;
  '/tickers': typeof AuthenticatedTickersIndexRoute;
  '/userSettings': typeof AuthenticatedUserSettingsIndexRoute;
  '/users': typeof AuthenticatedUsersIndexRoute;
  '/articles/$id/metadata': typeof AuthenticatedArticlesIdMetadataRoute;
  '/articles/$id/push': typeof AuthenticatedArticlesIdPushRoute;
  '/breakingnews/$id/metadata': typeof AuthenticatedBreakingnewsIdMetadataRoute;
  '/breakingnews/$id/push': typeof AuthenticatedBreakingnewsIdPushRoute;
  '/externalContent/embeds/new': typeof AuthenticatedExternalContentEmbedsNewRoute;
  '/externalContent/links/new': typeof AuthenticatedExternalContentLinksNewRoute;
  '/externalContent/videos/new': typeof AuthenticatedExternalContentVideosNewRoute;
  '/isolated/{-$scenarioName}/{-$preset}': typeof AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125Route;
  '/placement/history/$metadataId': typeof AuthenticatedPlacementHistoryMetadataIdRoute;
  '/slideshows/$id/metadata': typeof AuthenticatedSlideshowsIdMetadataRoute;
  '/slideshows/$id/push': typeof AuthenticatedSlideshowsIdPushRoute;
  '/teams/iceHockeyTeams/$id': typeof AuthenticatedTeamsIceHockeyTeamsIdRoute;
  '/teams/iceHockeyTeams/new': typeof AuthenticatedTeamsIceHockeyTeamsNewRoute;
  '/teams/leaguesAndTournaments/$id': typeof AuthenticatedTeamsLeaguesAndTournamentsIdRoute;
  '/teams/leaguesAndTournaments/new': typeof AuthenticatedTeamsLeaguesAndTournamentsNewRoute;
  '/teams/soccerTeams/$id': typeof AuthenticatedTeamsSoccerTeamsIdRoute;
  '/teams/soccerTeams/new': typeof AuthenticatedTeamsSoccerTeamsNewRoute;
  '/teams/tennisPlayers/$id': typeof AuthenticatedTeamsTennisPlayersIdRoute;
  '/teams/tennisPlayers/new': typeof AuthenticatedTeamsTennisPlayersNewRoute;
  '/tickers/$id/metadata': typeof AuthenticatedTickersIdMetadataRoute;
  '/tickers/$id/push': typeof AuthenticatedTickersIdPushRoute;
  '/articles/$id': typeof AuthenticatedArticlesIdIndexRoute;
  '/breakingnews/$id': typeof AuthenticatedBreakingnewsIdIndexRoute;
  '/externalContent/embeds': typeof AuthenticatedExternalContentEmbedsIndexRoute;
  '/externalContent/links': typeof AuthenticatedExternalContentLinksIndexRoute;
  '/externalContent/videos': typeof AuthenticatedExternalContentVideosIndexRoute;
  '/sitemaps/$tenantId': typeof AuthenticatedSitemapsTenantIdIndexRoute;
  '/teams/iceHockeyTeams': typeof AuthenticatedTeamsIceHockeyTeamsIndexRoute;
  '/teams/leaguesAndTournaments': typeof AuthenticatedTeamsLeaguesAndTournamentsIndexRoute;
  '/teams/soccerTeams': typeof AuthenticatedTeamsSoccerTeamsIndexRoute;
  '/teams/tennisPlayers': typeof AuthenticatedTeamsTennisPlayersIndexRoute;
  '/tickers/$id': typeof AuthenticatedTickersIdIndexRoute;
  '/articles/$id/revisions/$revisionId': typeof AuthenticatedArticlesIdRevisionsRevisionIdRoute;
  '/externalContent/embeds/$id/metadata': typeof AuthenticatedExternalContentEmbedsIdMetadataRoute;
  '/externalContent/embeds/$id/push': typeof AuthenticatedExternalContentEmbedsIdPushRoute;
  '/externalContent/links/$id/metadata': typeof AuthenticatedExternalContentLinksIdMetadataRoute;
  '/externalContent/links/$id/push': typeof AuthenticatedExternalContentLinksIdPushRoute;
  '/externalContent/videos/$id/metadata': typeof AuthenticatedExternalContentVideosIdMetadataRoute;
  '/externalContent/videos/$id/push': typeof AuthenticatedExternalContentVideosIdPushRoute;
  '/preview/metadata/$metadataId/{-$tenantId}': typeof AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125Route;
  '/preview/placement/$sectionId/$tenantId': typeof AuthenticatedPreviewPlacementSectionIdTenantIdRoute;
  '/sitemaps/$tenantId/nodes/$sitemapNodeId': typeof AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRoute;
  '/sitemaps/$tenantId/nodes/new': typeof AuthenticatedSitemapsTenantIdNodesNewRoute;
  '/externalContent/embeds/$id': typeof AuthenticatedExternalContentEmbedsIdIndexRoute;
  '/externalContent/links/$id': typeof AuthenticatedExternalContentLinksIdIndexRoute;
  '/externalContent/videos/$id': typeof AuthenticatedExternalContentVideosIdIndexRoute;
  '/placement/$tenantId/category/$categoryId/sections': typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteWithChildren;
  '/placement/$tenantId/tag/$tagId/sections': typeof AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteWithChildren;
  '/slideshows/$id/slides/$slideId': typeof AuthenticatedSlideshowsIdContentSlidesSlideIdRoute;
  '/slideshows/$id/slides/bulk': typeof AuthenticatedSlideshowsIdContentSlidesBulkRoute;
  '/placement/$tenantId/category/$categoryId/sections/$sectionId': typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRoute;
  '/placement/$tenantId/category/$categoryId/sections/new': typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRoute;
  '/placement/$tenantId/tag/$tagId/sections/$sectionId': typeof AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRoute;
  '/placement/$tenantId/tag/$tagId/sections/new': typeof AuthenticatedPlacementTenantIdTagTagIdSectionsNewRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/401': typeof R401Route;
  '/403': typeof R403Route;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/login': typeof LoginRoute;
  '/_authenticated/categories': typeof AuthenticatedCategoriesRouteRouteWithChildren;
  '/_authenticated/collections': typeof AuthenticatedCollectionsRouteRouteWithChildren;
  '/_authenticated/geneea-entities': typeof AuthenticatedGeneeaEntitiesRouteRouteWithChildren;
  '/_authenticated/kickwords': typeof AuthenticatedKickwordsRouteRouteWithChildren;
  '/_authenticated/newsletters': typeof AuthenticatedNewslettersRouteRouteWithChildren;
  '/_authenticated/placement': typeof AuthenticatedPlacementRouteRouteWithChildren;
  '/_authenticated/releasenotes': typeof AuthenticatedReleasenotesRouteRouteWithChildren;
  '/_authenticated/rtelements': typeof AuthenticatedRtelementsRouteRouteWithChildren;
  '/_authenticated/sitemaps': typeof AuthenticatedSitemapsRouteRouteWithChildren;
  '/_authenticated/tags': typeof AuthenticatedTagsRouteRouteWithChildren;
  '/_authenticated/teams': typeof AuthenticatedTeamsRouteRouteWithChildren;
  '/_authenticated/users': typeof AuthenticatedUsersRouteRouteWithChildren;
  '/_authenticated/$': typeof AuthenticatedSplatRoute;
  '/_authenticated/articles/$id': typeof AuthenticatedArticlesIdRouteRouteWithChildren;
  '/_authenticated/breakingnews/$id': typeof AuthenticatedBreakingnewsIdRouteRouteWithChildren;
  '/_authenticated/sitemaps/$tenantId': typeof AuthenticatedSitemapsTenantIdRouteRouteWithChildren;
  '/_authenticated/slideshows/$id': typeof AuthenticatedSlideshowsIdRouteRouteWithChildren;
  '/_authenticated/teams/iceHockeyTeams': typeof AuthenticatedTeamsIceHockeyTeamsRouteRouteWithChildren;
  '/_authenticated/teams/leaguesAndTournaments': typeof AuthenticatedTeamsLeaguesAndTournamentsRouteRouteWithChildren;
  '/_authenticated/teams/soccerTeams': typeof AuthenticatedTeamsSoccerTeamsRouteRouteWithChildren;
  '/_authenticated/teams/tennisPlayers': typeof AuthenticatedTeamsTennisPlayersRouteRouteWithChildren;
  '/_authenticated/tickers/$id': typeof AuthenticatedTickersIdRouteRouteWithChildren;
  '/_authenticated/articles/new': typeof AuthenticatedArticlesNewRoute;
  '/_authenticated/breakingnews/new': typeof AuthenticatedBreakingnewsNewRoute;
  '/_authenticated/categories/$id': typeof AuthenticatedCategoriesIdRoute;
  '/_authenticated/categories/new': typeof AuthenticatedCategoriesNewRoute;
  '/_authenticated/collections/$collectionId': typeof AuthenticatedCollectionsCollectionIdRoute;
  '/_authenticated/geneea-entities/$id': typeof AuthenticatedGeneeaEntitiesIdRoute;
  '/_authenticated/kickwords/$id': typeof AuthenticatedKickwordsIdRoute;
  '/_authenticated/kickwords/new': typeof AuthenticatedKickwordsNewRoute;
  '/_authenticated/maintenancenotes/$id': typeof AuthenticatedMaintenancenotesIdRoute;
  '/_authenticated/newsletters/$id': typeof AuthenticatedNewslettersIdRoute;
  '/_authenticated/releasenotes/$id': typeof AuthenticatedReleasenotesIdRoute;
  '/_authenticated/releasenotes/new': typeof AuthenticatedReleasenotesNewRoute;
  '/_authenticated/rtelements/$elementId': typeof AuthenticatedRtelementsElementIdRoute;
  '/_authenticated/rtelements/new': typeof AuthenticatedRtelementsNewRoute;
  '/_authenticated/slideshows/new': typeof AuthenticatedSlideshowsNewRoute;
  '/_authenticated/tags/$id': typeof AuthenticatedTagsIdRoute;
  '/_authenticated/tags/new': typeof AuthenticatedTagsNewRoute;
  '/_authenticated/tickers/new': typeof AuthenticatedTickersNewRoute;
  '/_authenticated/users/$id': typeof AuthenticatedUsersIdRoute;
  '/_authenticated/users/new': typeof AuthenticatedUsersNewRoute;
  '/_authenticated/(home)/': typeof AuthenticatedhomeIndexRoute;
  '/_authenticated/articles/': typeof AuthenticatedArticlesIndexRoute;
  '/_authenticated/breakingnews/': typeof AuthenticatedBreakingnewsIndexRoute;
  '/_authenticated/categories/': typeof AuthenticatedCategoriesIndexRoute;
  '/_authenticated/collections/': typeof AuthenticatedCollectionsIndexRoute;
  '/_authenticated/curatedList/': typeof AuthenticatedCuratedListIndexRoute;
  '/_authenticated/geneea-entities/': typeof AuthenticatedGeneeaEntitiesIndexRoute;
  '/_authenticated/kickwords/': typeof AuthenticatedKickwordsIndexRoute;
  '/_authenticated/newsletters/': typeof AuthenticatedNewslettersIndexRoute;
  '/_authenticated/placement/': typeof AuthenticatedPlacementIndexRoute;
  '/_authenticated/plate/': typeof AuthenticatedPlateIndexRoute;
  '/_authenticated/releasenotes/': typeof AuthenticatedReleasenotesIndexRoute;
  '/_authenticated/rtelements/': typeof AuthenticatedRtelementsIndexRoute;
  '/_authenticated/sitemaps/': typeof AuthenticatedSitemapsIndexRoute;
  '/_authenticated/slideshows/': typeof AuthenticatedSlideshowsIndexRoute;
  '/_authenticated/tags/': typeof AuthenticatedTagsIndexRoute;
  '/_authenticated/teams/': typeof AuthenticatedTeamsIndexRoute;
  '/_authenticated/tickers/': typeof AuthenticatedTickersIndexRoute;
  '/_authenticated/userSettings/': typeof AuthenticatedUserSettingsIndexRoute;
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute;
  '/_authenticated/externalContent/embeds/$id': typeof AuthenticatedExternalContentEmbedsIdRouteRouteWithChildren;
  '/_authenticated/externalContent/links/$id': typeof AuthenticatedExternalContentLinksIdRouteRouteWithChildren;
  '/_authenticated/externalContent/videos/$id': typeof AuthenticatedExternalContentVideosIdRouteRouteWithChildren;
  '/_authenticated/articles/$id/metadata': typeof AuthenticatedArticlesIdMetadataRoute;
  '/_authenticated/articles/$id/push': typeof AuthenticatedArticlesIdPushRoute;
  '/_authenticated/breakingnews/$id/metadata': typeof AuthenticatedBreakingnewsIdMetadataRoute;
  '/_authenticated/breakingnews/$id/push': typeof AuthenticatedBreakingnewsIdPushRoute;
  '/_authenticated/externalContent/embeds/new': typeof AuthenticatedExternalContentEmbedsNewRoute;
  '/_authenticated/externalContent/links/new': typeof AuthenticatedExternalContentLinksNewRoute;
  '/_authenticated/externalContent/videos/new': typeof AuthenticatedExternalContentVideosNewRoute;
  '/_authenticated/isolated/{-$scenarioName}/{-$preset}': typeof AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125Route;
  '/_authenticated/placement/history/$metadataId': typeof AuthenticatedPlacementHistoryMetadataIdRoute;
  '/_authenticated/slideshows/$id/_content': typeof AuthenticatedSlideshowsIdContentRouteWithChildren;
  '/_authenticated/slideshows/$id/metadata': typeof AuthenticatedSlideshowsIdMetadataRoute;
  '/_authenticated/slideshows/$id/push': typeof AuthenticatedSlideshowsIdPushRoute;
  '/_authenticated/teams/iceHockeyTeams/$id': typeof AuthenticatedTeamsIceHockeyTeamsIdRoute;
  '/_authenticated/teams/iceHockeyTeams/new': typeof AuthenticatedTeamsIceHockeyTeamsNewRoute;
  '/_authenticated/teams/leaguesAndTournaments/$id': typeof AuthenticatedTeamsLeaguesAndTournamentsIdRoute;
  '/_authenticated/teams/leaguesAndTournaments/new': typeof AuthenticatedTeamsLeaguesAndTournamentsNewRoute;
  '/_authenticated/teams/soccerTeams/$id': typeof AuthenticatedTeamsSoccerTeamsIdRoute;
  '/_authenticated/teams/soccerTeams/new': typeof AuthenticatedTeamsSoccerTeamsNewRoute;
  '/_authenticated/teams/tennisPlayers/$id': typeof AuthenticatedTeamsTennisPlayersIdRoute;
  '/_authenticated/teams/tennisPlayers/new': typeof AuthenticatedTeamsTennisPlayersNewRoute;
  '/_authenticated/tickers/$id/metadata': typeof AuthenticatedTickersIdMetadataRoute;
  '/_authenticated/tickers/$id/push': typeof AuthenticatedTickersIdPushRoute;
  '/_authenticated/articles/$id/': typeof AuthenticatedArticlesIdIndexRoute;
  '/_authenticated/breakingnews/$id/': typeof AuthenticatedBreakingnewsIdIndexRoute;
  '/_authenticated/externalContent/embeds/': typeof AuthenticatedExternalContentEmbedsIndexRoute;
  '/_authenticated/externalContent/links/': typeof AuthenticatedExternalContentLinksIndexRoute;
  '/_authenticated/externalContent/videos/': typeof AuthenticatedExternalContentVideosIndexRoute;
  '/_authenticated/sitemaps/$tenantId/': typeof AuthenticatedSitemapsTenantIdIndexRoute;
  '/_authenticated/teams/iceHockeyTeams/': typeof AuthenticatedTeamsIceHockeyTeamsIndexRoute;
  '/_authenticated/teams/leaguesAndTournaments/': typeof AuthenticatedTeamsLeaguesAndTournamentsIndexRoute;
  '/_authenticated/teams/soccerTeams/': typeof AuthenticatedTeamsSoccerTeamsIndexRoute;
  '/_authenticated/teams/tennisPlayers/': typeof AuthenticatedTeamsTennisPlayersIndexRoute;
  '/_authenticated/tickers/$id/': typeof AuthenticatedTickersIdIndexRoute;
  '/_authenticated/articles/$id/revisions/$revisionId': typeof AuthenticatedArticlesIdRevisionsRevisionIdRoute;
  '/_authenticated/externalContent/embeds/$id/metadata': typeof AuthenticatedExternalContentEmbedsIdMetadataRoute;
  '/_authenticated/externalContent/embeds/$id/push': typeof AuthenticatedExternalContentEmbedsIdPushRoute;
  '/_authenticated/externalContent/links/$id/metadata': typeof AuthenticatedExternalContentLinksIdMetadataRoute;
  '/_authenticated/externalContent/links/$id/push': typeof AuthenticatedExternalContentLinksIdPushRoute;
  '/_authenticated/externalContent/videos/$id/metadata': typeof AuthenticatedExternalContentVideosIdMetadataRoute;
  '/_authenticated/externalContent/videos/$id/push': typeof AuthenticatedExternalContentVideosIdPushRoute;
  '/_authenticated/preview/metadata/$metadataId/{-$tenantId}': typeof AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125Route;
  '/_authenticated/preview/placement/$sectionId/$tenantId': typeof AuthenticatedPreviewPlacementSectionIdTenantIdRoute;
  '/_authenticated/sitemaps/$tenantId/nodes/$sitemapNodeId': typeof AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRoute;
  '/_authenticated/sitemaps/$tenantId/nodes/new': typeof AuthenticatedSitemapsTenantIdNodesNewRoute;
  '/_authenticated/externalContent/embeds/$id/': typeof AuthenticatedExternalContentEmbedsIdIndexRoute;
  '/_authenticated/externalContent/links/$id/': typeof AuthenticatedExternalContentLinksIdIndexRoute;
  '/_authenticated/externalContent/videos/$id/': typeof AuthenticatedExternalContentVideosIdIndexRoute;
  '/_authenticated/slideshows/$id/_content/': typeof AuthenticatedSlideshowsIdContentIndexRoute;
  '/_authenticated/placement/$tenantId/category/$categoryId/sections': typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteWithChildren;
  '/_authenticated/placement/$tenantId/tag/$tagId/sections': typeof AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteWithChildren;
  '/_authenticated/slideshows/$id/_content/slides/$slideId': typeof AuthenticatedSlideshowsIdContentSlidesSlideIdRoute;
  '/_authenticated/slideshows/$id/_content/slides/bulk': typeof AuthenticatedSlideshowsIdContentSlidesBulkRoute;
  '/_authenticated/placement/$tenantId/category/$categoryId/sections/$sectionId': typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRoute;
  '/_authenticated/placement/$tenantId/category/$categoryId/sections/new': typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRoute;
  '/_authenticated/placement/$tenantId/tag/$tagId/sections/$sectionId': typeof AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRoute;
  '/_authenticated/placement/$tenantId/tag/$tagId/sections/new': typeof AuthenticatedPlacementTenantIdTagTagIdSectionsNewRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/401'
    | '/403'
    | '/'
    | '/login'
    | '/categories'
    | '/collections'
    | '/geneea-entities'
    | '/kickwords'
    | '/newsletters'
    | '/placement'
    | '/releasenotes'
    | '/rtelements'
    | '/sitemaps'
    | '/tags'
    | '/teams'
    | '/users'
    | '/$'
    | '/articles/$id'
    | '/breakingnews/$id'
    | '/sitemaps/$tenantId'
    | '/slideshows/$id'
    | '/teams/iceHockeyTeams'
    | '/teams/leaguesAndTournaments'
    | '/teams/soccerTeams'
    | '/teams/tennisPlayers'
    | '/tickers/$id'
    | '/articles/new'
    | '/breakingnews/new'
    | '/categories/$id'
    | '/categories/new'
    | '/collections/$collectionId'
    | '/geneea-entities/$id'
    | '/kickwords/$id'
    | '/kickwords/new'
    | '/maintenancenotes/$id'
    | '/newsletters/$id'
    | '/releasenotes/$id'
    | '/releasenotes/new'
    | '/rtelements/$elementId'
    | '/rtelements/new'
    | '/slideshows/new'
    | '/tags/$id'
    | '/tags/new'
    | '/tickers/new'
    | '/users/$id'
    | '/users/new'
    | '/articles/'
    | '/breakingnews/'
    | '/categories/'
    | '/collections/'
    | '/curatedList/'
    | '/geneea-entities/'
    | '/kickwords/'
    | '/newsletters/'
    | '/placement/'
    | '/plate/'
    | '/releasenotes/'
    | '/rtelements/'
    | '/sitemaps/'
    | '/slideshows/'
    | '/tags/'
    | '/teams/'
    | '/tickers/'
    | '/userSettings/'
    | '/users/'
    | '/externalContent/embeds/$id'
    | '/externalContent/links/$id'
    | '/externalContent/videos/$id'
    | '/articles/$id/metadata'
    | '/articles/$id/push'
    | '/breakingnews/$id/metadata'
    | '/breakingnews/$id/push'
    | '/externalContent/embeds/new'
    | '/externalContent/links/new'
    | '/externalContent/videos/new'
    | '/isolated/{-$scenarioName}/{-$preset}'
    | '/placement/history/$metadataId'
    | '/slideshows/$id/metadata'
    | '/slideshows/$id/push'
    | '/teams/iceHockeyTeams/$id'
    | '/teams/iceHockeyTeams/new'
    | '/teams/leaguesAndTournaments/$id'
    | '/teams/leaguesAndTournaments/new'
    | '/teams/soccerTeams/$id'
    | '/teams/soccerTeams/new'
    | '/teams/tennisPlayers/$id'
    | '/teams/tennisPlayers/new'
    | '/tickers/$id/metadata'
    | '/tickers/$id/push'
    | '/articles/$id/'
    | '/breakingnews/$id/'
    | '/externalContent/embeds/'
    | '/externalContent/links/'
    | '/externalContent/videos/'
    | '/sitemaps/$tenantId/'
    | '/teams/iceHockeyTeams/'
    | '/teams/leaguesAndTournaments/'
    | '/teams/soccerTeams/'
    | '/teams/tennisPlayers/'
    | '/tickers/$id/'
    | '/articles/$id/revisions/$revisionId'
    | '/externalContent/embeds/$id/metadata'
    | '/externalContent/embeds/$id/push'
    | '/externalContent/links/$id/metadata'
    | '/externalContent/links/$id/push'
    | '/externalContent/videos/$id/metadata'
    | '/externalContent/videos/$id/push'
    | '/preview/metadata/$metadataId/{-$tenantId}'
    | '/preview/placement/$sectionId/$tenantId'
    | '/sitemaps/$tenantId/nodes/$sitemapNodeId'
    | '/sitemaps/$tenantId/nodes/new'
    | '/externalContent/embeds/$id/'
    | '/externalContent/links/$id/'
    | '/externalContent/videos/$id/'
    | '/slideshows/$id/'
    | '/placement/$tenantId/category/$categoryId/sections'
    | '/placement/$tenantId/tag/$tagId/sections'
    | '/slideshows/$id/slides/$slideId'
    | '/slideshows/$id/slides/bulk'
    | '/placement/$tenantId/category/$categoryId/sections/$sectionId'
    | '/placement/$tenantId/category/$categoryId/sections/new'
    | '/placement/$tenantId/tag/$tagId/sections/$sectionId'
    | '/placement/$tenantId/tag/$tagId/sections/new';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/401'
    | '/403'
    | '/login'
    | '/$'
    | '/slideshows/$id'
    | '/articles/new'
    | '/breakingnews/new'
    | '/categories/$id'
    | '/categories/new'
    | '/collections/$collectionId'
    | '/geneea-entities/$id'
    | '/kickwords/$id'
    | '/kickwords/new'
    | '/maintenancenotes/$id'
    | '/newsletters/$id'
    | '/releasenotes/$id'
    | '/releasenotes/new'
    | '/rtelements/$elementId'
    | '/rtelements/new'
    | '/slideshows/new'
    | '/tags/$id'
    | '/tags/new'
    | '/tickers/new'
    | '/users/$id'
    | '/users/new'
    | '/'
    | '/articles'
    | '/breakingnews'
    | '/categories'
    | '/collections'
    | '/curatedList'
    | '/geneea-entities'
    | '/kickwords'
    | '/newsletters'
    | '/placement'
    | '/plate'
    | '/releasenotes'
    | '/rtelements'
    | '/sitemaps'
    | '/slideshows'
    | '/tags'
    | '/teams'
    | '/tickers'
    | '/userSettings'
    | '/users'
    | '/articles/$id/metadata'
    | '/articles/$id/push'
    | '/breakingnews/$id/metadata'
    | '/breakingnews/$id/push'
    | '/externalContent/embeds/new'
    | '/externalContent/links/new'
    | '/externalContent/videos/new'
    | '/isolated/{-$scenarioName}/{-$preset}'
    | '/placement/history/$metadataId'
    | '/slideshows/$id/metadata'
    | '/slideshows/$id/push'
    | '/teams/iceHockeyTeams/$id'
    | '/teams/iceHockeyTeams/new'
    | '/teams/leaguesAndTournaments/$id'
    | '/teams/leaguesAndTournaments/new'
    | '/teams/soccerTeams/$id'
    | '/teams/soccerTeams/new'
    | '/teams/tennisPlayers/$id'
    | '/teams/tennisPlayers/new'
    | '/tickers/$id/metadata'
    | '/tickers/$id/push'
    | '/articles/$id'
    | '/breakingnews/$id'
    | '/externalContent/embeds'
    | '/externalContent/links'
    | '/externalContent/videos'
    | '/sitemaps/$tenantId'
    | '/teams/iceHockeyTeams'
    | '/teams/leaguesAndTournaments'
    | '/teams/soccerTeams'
    | '/teams/tennisPlayers'
    | '/tickers/$id'
    | '/articles/$id/revisions/$revisionId'
    | '/externalContent/embeds/$id/metadata'
    | '/externalContent/embeds/$id/push'
    | '/externalContent/links/$id/metadata'
    | '/externalContent/links/$id/push'
    | '/externalContent/videos/$id/metadata'
    | '/externalContent/videos/$id/push'
    | '/preview/metadata/$metadataId/{-$tenantId}'
    | '/preview/placement/$sectionId/$tenantId'
    | '/sitemaps/$tenantId/nodes/$sitemapNodeId'
    | '/sitemaps/$tenantId/nodes/new'
    | '/externalContent/embeds/$id'
    | '/externalContent/links/$id'
    | '/externalContent/videos/$id'
    | '/placement/$tenantId/category/$categoryId/sections'
    | '/placement/$tenantId/tag/$tagId/sections'
    | '/slideshows/$id/slides/$slideId'
    | '/slideshows/$id/slides/bulk'
    | '/placement/$tenantId/category/$categoryId/sections/$sectionId'
    | '/placement/$tenantId/category/$categoryId/sections/new'
    | '/placement/$tenantId/tag/$tagId/sections/$sectionId'
    | '/placement/$tenantId/tag/$tagId/sections/new';
  id:
    | '__root__'
    | '/401'
    | '/403'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/categories'
    | '/_authenticated/collections'
    | '/_authenticated/geneea-entities'
    | '/_authenticated/kickwords'
    | '/_authenticated/newsletters'
    | '/_authenticated/placement'
    | '/_authenticated/releasenotes'
    | '/_authenticated/rtelements'
    | '/_authenticated/sitemaps'
    | '/_authenticated/tags'
    | '/_authenticated/teams'
    | '/_authenticated/users'
    | '/_authenticated/$'
    | '/_authenticated/articles/$id'
    | '/_authenticated/breakingnews/$id'
    | '/_authenticated/sitemaps/$tenantId'
    | '/_authenticated/slideshows/$id'
    | '/_authenticated/teams/iceHockeyTeams'
    | '/_authenticated/teams/leaguesAndTournaments'
    | '/_authenticated/teams/soccerTeams'
    | '/_authenticated/teams/tennisPlayers'
    | '/_authenticated/tickers/$id'
    | '/_authenticated/articles/new'
    | '/_authenticated/breakingnews/new'
    | '/_authenticated/categories/$id'
    | '/_authenticated/categories/new'
    | '/_authenticated/collections/$collectionId'
    | '/_authenticated/geneea-entities/$id'
    | '/_authenticated/kickwords/$id'
    | '/_authenticated/kickwords/new'
    | '/_authenticated/maintenancenotes/$id'
    | '/_authenticated/newsletters/$id'
    | '/_authenticated/releasenotes/$id'
    | '/_authenticated/releasenotes/new'
    | '/_authenticated/rtelements/$elementId'
    | '/_authenticated/rtelements/new'
    | '/_authenticated/slideshows/new'
    | '/_authenticated/tags/$id'
    | '/_authenticated/tags/new'
    | '/_authenticated/tickers/new'
    | '/_authenticated/users/$id'
    | '/_authenticated/users/new'
    | '/_authenticated/(home)/'
    | '/_authenticated/articles/'
    | '/_authenticated/breakingnews/'
    | '/_authenticated/categories/'
    | '/_authenticated/collections/'
    | '/_authenticated/curatedList/'
    | '/_authenticated/geneea-entities/'
    | '/_authenticated/kickwords/'
    | '/_authenticated/newsletters/'
    | '/_authenticated/placement/'
    | '/_authenticated/plate/'
    | '/_authenticated/releasenotes/'
    | '/_authenticated/rtelements/'
    | '/_authenticated/sitemaps/'
    | '/_authenticated/slideshows/'
    | '/_authenticated/tags/'
    | '/_authenticated/teams/'
    | '/_authenticated/tickers/'
    | '/_authenticated/userSettings/'
    | '/_authenticated/users/'
    | '/_authenticated/externalContent/embeds/$id'
    | '/_authenticated/externalContent/links/$id'
    | '/_authenticated/externalContent/videos/$id'
    | '/_authenticated/articles/$id/metadata'
    | '/_authenticated/articles/$id/push'
    | '/_authenticated/breakingnews/$id/metadata'
    | '/_authenticated/breakingnews/$id/push'
    | '/_authenticated/externalContent/embeds/new'
    | '/_authenticated/externalContent/links/new'
    | '/_authenticated/externalContent/videos/new'
    | '/_authenticated/isolated/{-$scenarioName}/{-$preset}'
    | '/_authenticated/placement/history/$metadataId'
    | '/_authenticated/slideshows/$id/_content'
    | '/_authenticated/slideshows/$id/metadata'
    | '/_authenticated/slideshows/$id/push'
    | '/_authenticated/teams/iceHockeyTeams/$id'
    | '/_authenticated/teams/iceHockeyTeams/new'
    | '/_authenticated/teams/leaguesAndTournaments/$id'
    | '/_authenticated/teams/leaguesAndTournaments/new'
    | '/_authenticated/teams/soccerTeams/$id'
    | '/_authenticated/teams/soccerTeams/new'
    | '/_authenticated/teams/tennisPlayers/$id'
    | '/_authenticated/teams/tennisPlayers/new'
    | '/_authenticated/tickers/$id/metadata'
    | '/_authenticated/tickers/$id/push'
    | '/_authenticated/articles/$id/'
    | '/_authenticated/breakingnews/$id/'
    | '/_authenticated/externalContent/embeds/'
    | '/_authenticated/externalContent/links/'
    | '/_authenticated/externalContent/videos/'
    | '/_authenticated/sitemaps/$tenantId/'
    | '/_authenticated/teams/iceHockeyTeams/'
    | '/_authenticated/teams/leaguesAndTournaments/'
    | '/_authenticated/teams/soccerTeams/'
    | '/_authenticated/teams/tennisPlayers/'
    | '/_authenticated/tickers/$id/'
    | '/_authenticated/articles/$id/revisions/$revisionId'
    | '/_authenticated/externalContent/embeds/$id/metadata'
    | '/_authenticated/externalContent/embeds/$id/push'
    | '/_authenticated/externalContent/links/$id/metadata'
    | '/_authenticated/externalContent/links/$id/push'
    | '/_authenticated/externalContent/videos/$id/metadata'
    | '/_authenticated/externalContent/videos/$id/push'
    | '/_authenticated/preview/metadata/$metadataId/{-$tenantId}'
    | '/_authenticated/preview/placement/$sectionId/$tenantId'
    | '/_authenticated/sitemaps/$tenantId/nodes/$sitemapNodeId'
    | '/_authenticated/sitemaps/$tenantId/nodes/new'
    | '/_authenticated/externalContent/embeds/$id/'
    | '/_authenticated/externalContent/links/$id/'
    | '/_authenticated/externalContent/videos/$id/'
    | '/_authenticated/slideshows/$id/_content/'
    | '/_authenticated/placement/$tenantId/category/$categoryId/sections'
    | '/_authenticated/placement/$tenantId/tag/$tagId/sections'
    | '/_authenticated/slideshows/$id/_content/slides/$slideId'
    | '/_authenticated/slideshows/$id/_content/slides/bulk'
    | '/_authenticated/placement/$tenantId/category/$categoryId/sections/$sectionId'
    | '/_authenticated/placement/$tenantId/category/$categoryId/sections/new'
    | '/_authenticated/placement/$tenantId/tag/$tagId/sections/$sectionId'
    | '/_authenticated/placement/$tenantId/tag/$tagId/sections/new';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  R401Route: typeof R401Route;
  R403Route: typeof R403Route;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/401': {
      id: '/401';
      path: '/401';
      fullPath: '/401';
      preLoaderRoute: typeof R401RouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/403': {
      id: '/403';
      path: '/403';
      fullPath: '/403';
      preLoaderRoute: typeof R403RouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/$': {
      id: '/_authenticated/$';
      path: '/$';
      fullPath: '/$';
      preLoaderRoute: typeof AuthenticatedSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/categories': {
      id: '/_authenticated/categories';
      path: '/categories';
      fullPath: '/categories';
      preLoaderRoute: typeof AuthenticatedCategoriesRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/collections': {
      id: '/_authenticated/collections';
      path: '/collections';
      fullPath: '/collections';
      preLoaderRoute: typeof AuthenticatedCollectionsRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/geneea-entities': {
      id: '/_authenticated/geneea-entities';
      path: '/geneea-entities';
      fullPath: '/geneea-entities';
      preLoaderRoute: typeof AuthenticatedGeneeaEntitiesRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/kickwords': {
      id: '/_authenticated/kickwords';
      path: '/kickwords';
      fullPath: '/kickwords';
      preLoaderRoute: typeof AuthenticatedKickwordsRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/newsletters': {
      id: '/_authenticated/newsletters';
      path: '/newsletters';
      fullPath: '/newsletters';
      preLoaderRoute: typeof AuthenticatedNewslettersRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/placement': {
      id: '/_authenticated/placement';
      path: '/placement';
      fullPath: '/placement';
      preLoaderRoute: typeof AuthenticatedPlacementRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/releasenotes': {
      id: '/_authenticated/releasenotes';
      path: '/releasenotes';
      fullPath: '/releasenotes';
      preLoaderRoute: typeof AuthenticatedReleasenotesRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/rtelements': {
      id: '/_authenticated/rtelements';
      path: '/rtelements';
      fullPath: '/rtelements';
      preLoaderRoute: typeof AuthenticatedRtelementsRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/sitemaps': {
      id: '/_authenticated/sitemaps';
      path: '/sitemaps';
      fullPath: '/sitemaps';
      preLoaderRoute: typeof AuthenticatedSitemapsRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tags': {
      id: '/_authenticated/tags';
      path: '/tags';
      fullPath: '/tags';
      preLoaderRoute: typeof AuthenticatedTagsRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/teams': {
      id: '/_authenticated/teams';
      path: '/teams';
      fullPath: '/teams';
      preLoaderRoute: typeof AuthenticatedTeamsRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/users': {
      id: '/_authenticated/users';
      path: '/users';
      fullPath: '/users';
      preLoaderRoute: typeof AuthenticatedUsersRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/(home)/': {
      id: '/_authenticated/(home)/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedhomeIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/articles/': {
      id: '/_authenticated/articles/';
      path: '/articles';
      fullPath: '/articles/';
      preLoaderRoute: typeof AuthenticatedArticlesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/articles/$id': {
      id: '/_authenticated/articles/$id';
      path: '/articles/$id';
      fullPath: '/articles/$id';
      preLoaderRoute: typeof AuthenticatedArticlesIdRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/articles/new': {
      id: '/_authenticated/articles/new';
      path: '/articles/new';
      fullPath: '/articles/new';
      preLoaderRoute: typeof AuthenticatedArticlesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/breakingnews/': {
      id: '/_authenticated/breakingnews/';
      path: '/breakingnews';
      fullPath: '/breakingnews/';
      preLoaderRoute: typeof AuthenticatedBreakingnewsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/breakingnews/$id': {
      id: '/_authenticated/breakingnews/$id';
      path: '/breakingnews/$id';
      fullPath: '/breakingnews/$id';
      preLoaderRoute: typeof AuthenticatedBreakingnewsIdRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/breakingnews/new': {
      id: '/_authenticated/breakingnews/new';
      path: '/breakingnews/new';
      fullPath: '/breakingnews/new';
      preLoaderRoute: typeof AuthenticatedBreakingnewsNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/categories/': {
      id: '/_authenticated/categories/';
      path: '/';
      fullPath: '/categories/';
      preLoaderRoute: typeof AuthenticatedCategoriesIndexRouteImport;
      parentRoute: typeof AuthenticatedCategoriesRouteRoute;
    };
    '/_authenticated/categories/$id': {
      id: '/_authenticated/categories/$id';
      path: '/$id';
      fullPath: '/categories/$id';
      preLoaderRoute: typeof AuthenticatedCategoriesIdRouteImport;
      parentRoute: typeof AuthenticatedCategoriesRouteRoute;
    };
    '/_authenticated/categories/new': {
      id: '/_authenticated/categories/new';
      path: '/new';
      fullPath: '/categories/new';
      preLoaderRoute: typeof AuthenticatedCategoriesNewRouteImport;
      parentRoute: typeof AuthenticatedCategoriesRouteRoute;
    };
    '/_authenticated/collections/': {
      id: '/_authenticated/collections/';
      path: '/';
      fullPath: '/collections/';
      preLoaderRoute: typeof AuthenticatedCollectionsIndexRouteImport;
      parentRoute: typeof AuthenticatedCollectionsRouteRoute;
    };
    '/_authenticated/collections/$collectionId': {
      id: '/_authenticated/collections/$collectionId';
      path: '/$collectionId';
      fullPath: '/collections/$collectionId';
      preLoaderRoute: typeof AuthenticatedCollectionsCollectionIdRouteImport;
      parentRoute: typeof AuthenticatedCollectionsRouteRoute;
    };
    '/_authenticated/curatedList/': {
      id: '/_authenticated/curatedList/';
      path: '/curatedList';
      fullPath: '/curatedList/';
      preLoaderRoute: typeof AuthenticatedCuratedListIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/geneea-entities/': {
      id: '/_authenticated/geneea-entities/';
      path: '/';
      fullPath: '/geneea-entities/';
      preLoaderRoute: typeof AuthenticatedGeneeaEntitiesIndexRouteImport;
      parentRoute: typeof AuthenticatedGeneeaEntitiesRouteRoute;
    };
    '/_authenticated/geneea-entities/$id': {
      id: '/_authenticated/geneea-entities/$id';
      path: '/$id';
      fullPath: '/geneea-entities/$id';
      preLoaderRoute: typeof AuthenticatedGeneeaEntitiesIdRouteImport;
      parentRoute: typeof AuthenticatedGeneeaEntitiesRouteRoute;
    };
    '/_authenticated/kickwords/': {
      id: '/_authenticated/kickwords/';
      path: '/';
      fullPath: '/kickwords/';
      preLoaderRoute: typeof AuthenticatedKickwordsIndexRouteImport;
      parentRoute: typeof AuthenticatedKickwordsRouteRoute;
    };
    '/_authenticated/kickwords/$id': {
      id: '/_authenticated/kickwords/$id';
      path: '/$id';
      fullPath: '/kickwords/$id';
      preLoaderRoute: typeof AuthenticatedKickwordsIdRouteImport;
      parentRoute: typeof AuthenticatedKickwordsRouteRoute;
    };
    '/_authenticated/kickwords/new': {
      id: '/_authenticated/kickwords/new';
      path: '/new';
      fullPath: '/kickwords/new';
      preLoaderRoute: typeof AuthenticatedKickwordsNewRouteImport;
      parentRoute: typeof AuthenticatedKickwordsRouteRoute;
    };
    '/_authenticated/maintenancenotes/$id': {
      id: '/_authenticated/maintenancenotes/$id';
      path: '/maintenancenotes/$id';
      fullPath: '/maintenancenotes/$id';
      preLoaderRoute: typeof AuthenticatedMaintenancenotesIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/newsletters/': {
      id: '/_authenticated/newsletters/';
      path: '/';
      fullPath: '/newsletters/';
      preLoaderRoute: typeof AuthenticatedNewslettersIndexRouteImport;
      parentRoute: typeof AuthenticatedNewslettersRouteRoute;
    };
    '/_authenticated/newsletters/$id': {
      id: '/_authenticated/newsletters/$id';
      path: '/$id';
      fullPath: '/newsletters/$id';
      preLoaderRoute: typeof AuthenticatedNewslettersIdRouteImport;
      parentRoute: typeof AuthenticatedNewslettersRouteRoute;
    };
    '/_authenticated/placement/': {
      id: '/_authenticated/placement/';
      path: '/';
      fullPath: '/placement/';
      preLoaderRoute: typeof AuthenticatedPlacementIndexRouteImport;
      parentRoute: typeof AuthenticatedPlacementRouteRoute;
    };
    '/_authenticated/plate/': {
      id: '/_authenticated/plate/';
      path: '/plate';
      fullPath: '/plate/';
      preLoaderRoute: typeof AuthenticatedPlateIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/releasenotes/': {
      id: '/_authenticated/releasenotes/';
      path: '/';
      fullPath: '/releasenotes/';
      preLoaderRoute: typeof AuthenticatedReleasenotesIndexRouteImport;
      parentRoute: typeof AuthenticatedReleasenotesRouteRoute;
    };
    '/_authenticated/releasenotes/$id': {
      id: '/_authenticated/releasenotes/$id';
      path: '/$id';
      fullPath: '/releasenotes/$id';
      preLoaderRoute: typeof AuthenticatedReleasenotesIdRouteImport;
      parentRoute: typeof AuthenticatedReleasenotesRouteRoute;
    };
    '/_authenticated/releasenotes/new': {
      id: '/_authenticated/releasenotes/new';
      path: '/new';
      fullPath: '/releasenotes/new';
      preLoaderRoute: typeof AuthenticatedReleasenotesNewRouteImport;
      parentRoute: typeof AuthenticatedReleasenotesRouteRoute;
    };
    '/_authenticated/rtelements/': {
      id: '/_authenticated/rtelements/';
      path: '/';
      fullPath: '/rtelements/';
      preLoaderRoute: typeof AuthenticatedRtelementsIndexRouteImport;
      parentRoute: typeof AuthenticatedRtelementsRouteRoute;
    };
    '/_authenticated/rtelements/$elementId': {
      id: '/_authenticated/rtelements/$elementId';
      path: '/$elementId';
      fullPath: '/rtelements/$elementId';
      preLoaderRoute: typeof AuthenticatedRtelementsElementIdRouteImport;
      parentRoute: typeof AuthenticatedRtelementsRouteRoute;
    };
    '/_authenticated/rtelements/new': {
      id: '/_authenticated/rtelements/new';
      path: '/new';
      fullPath: '/rtelements/new';
      preLoaderRoute: typeof AuthenticatedRtelementsNewRouteImport;
      parentRoute: typeof AuthenticatedRtelementsRouteRoute;
    };
    '/_authenticated/sitemaps/': {
      id: '/_authenticated/sitemaps/';
      path: '/';
      fullPath: '/sitemaps/';
      preLoaderRoute: typeof AuthenticatedSitemapsIndexRouteImport;
      parentRoute: typeof AuthenticatedSitemapsRouteRoute;
    };
    '/_authenticated/sitemaps/$tenantId': {
      id: '/_authenticated/sitemaps/$tenantId';
      path: '/$tenantId';
      fullPath: '/sitemaps/$tenantId';
      preLoaderRoute: typeof AuthenticatedSitemapsTenantIdRouteRouteImport;
      parentRoute: typeof AuthenticatedSitemapsRouteRoute;
    };
    '/_authenticated/slideshows/': {
      id: '/_authenticated/slideshows/';
      path: '/slideshows';
      fullPath: '/slideshows/';
      preLoaderRoute: typeof AuthenticatedSlideshowsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/slideshows/$id': {
      id: '/_authenticated/slideshows/$id';
      path: '/slideshows/$id';
      fullPath: '/slideshows/$id';
      preLoaderRoute: typeof AuthenticatedSlideshowsIdRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/slideshows/new': {
      id: '/_authenticated/slideshows/new';
      path: '/slideshows/new';
      fullPath: '/slideshows/new';
      preLoaderRoute: typeof AuthenticatedSlideshowsNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tags/': {
      id: '/_authenticated/tags/';
      path: '/';
      fullPath: '/tags/';
      preLoaderRoute: typeof AuthenticatedTagsIndexRouteImport;
      parentRoute: typeof AuthenticatedTagsRouteRoute;
    };
    '/_authenticated/tags/$id': {
      id: '/_authenticated/tags/$id';
      path: '/$id';
      fullPath: '/tags/$id';
      preLoaderRoute: typeof AuthenticatedTagsIdRouteImport;
      parentRoute: typeof AuthenticatedTagsRouteRoute;
    };
    '/_authenticated/tags/new': {
      id: '/_authenticated/tags/new';
      path: '/new';
      fullPath: '/tags/new';
      preLoaderRoute: typeof AuthenticatedTagsNewRouteImport;
      parentRoute: typeof AuthenticatedTagsRouteRoute;
    };
    '/_authenticated/teams/': {
      id: '/_authenticated/teams/';
      path: '/';
      fullPath: '/teams/';
      preLoaderRoute: typeof AuthenticatedTeamsIndexRouteImport;
      parentRoute: typeof AuthenticatedTeamsRouteRoute;
    };
    '/_authenticated/teams/iceHockeyTeams': {
      id: '/_authenticated/teams/iceHockeyTeams';
      path: '/iceHockeyTeams';
      fullPath: '/teams/iceHockeyTeams';
      preLoaderRoute: typeof AuthenticatedTeamsIceHockeyTeamsRouteRouteImport;
      parentRoute: typeof AuthenticatedTeamsRouteRoute;
    };
    '/_authenticated/teams/leaguesAndTournaments': {
      id: '/_authenticated/teams/leaguesAndTournaments';
      path: '/leaguesAndTournaments';
      fullPath: '/teams/leaguesAndTournaments';
      preLoaderRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsRouteRouteImport;
      parentRoute: typeof AuthenticatedTeamsRouteRoute;
    };
    '/_authenticated/teams/soccerTeams': {
      id: '/_authenticated/teams/soccerTeams';
      path: '/soccerTeams';
      fullPath: '/teams/soccerTeams';
      preLoaderRoute: typeof AuthenticatedTeamsSoccerTeamsRouteRouteImport;
      parentRoute: typeof AuthenticatedTeamsRouteRoute;
    };
    '/_authenticated/teams/tennisPlayers': {
      id: '/_authenticated/teams/tennisPlayers';
      path: '/tennisPlayers';
      fullPath: '/teams/tennisPlayers';
      preLoaderRoute: typeof AuthenticatedTeamsTennisPlayersRouteRouteImport;
      parentRoute: typeof AuthenticatedTeamsRouteRoute;
    };
    '/_authenticated/tickers/': {
      id: '/_authenticated/tickers/';
      path: '/tickers';
      fullPath: '/tickers/';
      preLoaderRoute: typeof AuthenticatedTickersIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tickers/$id': {
      id: '/_authenticated/tickers/$id';
      path: '/tickers/$id';
      fullPath: '/tickers/$id';
      preLoaderRoute: typeof AuthenticatedTickersIdRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tickers/new': {
      id: '/_authenticated/tickers/new';
      path: '/tickers/new';
      fullPath: '/tickers/new';
      preLoaderRoute: typeof AuthenticatedTickersNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/userSettings/': {
      id: '/_authenticated/userSettings/';
      path: '/userSettings';
      fullPath: '/userSettings/';
      preLoaderRoute: typeof AuthenticatedUserSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/users/': {
      id: '/_authenticated/users/';
      path: '/';
      fullPath: '/users/';
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport;
      parentRoute: typeof AuthenticatedUsersRouteRoute;
    };
    '/_authenticated/users/$id': {
      id: '/_authenticated/users/$id';
      path: '/$id';
      fullPath: '/users/$id';
      preLoaderRoute: typeof AuthenticatedUsersIdRouteImport;
      parentRoute: typeof AuthenticatedUsersRouteRoute;
    };
    '/_authenticated/users/new': {
      id: '/_authenticated/users/new';
      path: '/new';
      fullPath: '/users/new';
      preLoaderRoute: typeof AuthenticatedUsersNewRouteImport;
      parentRoute: typeof AuthenticatedUsersRouteRoute;
    };
    '/_authenticated/articles/$id/': {
      id: '/_authenticated/articles/$id/';
      path: '/';
      fullPath: '/articles/$id/';
      preLoaderRoute: typeof AuthenticatedArticlesIdIndexRouteImport;
      parentRoute: typeof AuthenticatedArticlesIdRouteRoute;
    };
    '/_authenticated/articles/$id/metadata': {
      id: '/_authenticated/articles/$id/metadata';
      path: '/metadata';
      fullPath: '/articles/$id/metadata';
      preLoaderRoute: typeof AuthenticatedArticlesIdMetadataRouteImport;
      parentRoute: typeof AuthenticatedArticlesIdRouteRoute;
    };
    '/_authenticated/articles/$id/push': {
      id: '/_authenticated/articles/$id/push';
      path: '/push';
      fullPath: '/articles/$id/push';
      preLoaderRoute: typeof AuthenticatedArticlesIdPushRouteImport;
      parentRoute: typeof AuthenticatedArticlesIdRouteRoute;
    };
    '/_authenticated/breakingnews/$id/': {
      id: '/_authenticated/breakingnews/$id/';
      path: '/';
      fullPath: '/breakingnews/$id/';
      preLoaderRoute: typeof AuthenticatedBreakingnewsIdIndexRouteImport;
      parentRoute: typeof AuthenticatedBreakingnewsIdRouteRoute;
    };
    '/_authenticated/breakingnews/$id/metadata': {
      id: '/_authenticated/breakingnews/$id/metadata';
      path: '/metadata';
      fullPath: '/breakingnews/$id/metadata';
      preLoaderRoute: typeof AuthenticatedBreakingnewsIdMetadataRouteImport;
      parentRoute: typeof AuthenticatedBreakingnewsIdRouteRoute;
    };
    '/_authenticated/breakingnews/$id/push': {
      id: '/_authenticated/breakingnews/$id/push';
      path: '/push';
      fullPath: '/breakingnews/$id/push';
      preLoaderRoute: typeof AuthenticatedBreakingnewsIdPushRouteImport;
      parentRoute: typeof AuthenticatedBreakingnewsIdRouteRoute;
    };
    '/_authenticated/externalContent/embeds/': {
      id: '/_authenticated/externalContent/embeds/';
      path: '/externalContent/embeds';
      fullPath: '/externalContent/embeds/';
      preLoaderRoute: typeof AuthenticatedExternalContentEmbedsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/externalContent/embeds/$id': {
      id: '/_authenticated/externalContent/embeds/$id';
      path: '/externalContent/embeds/$id';
      fullPath: '/externalContent/embeds/$id';
      preLoaderRoute: typeof AuthenticatedExternalContentEmbedsIdRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/externalContent/embeds/new': {
      id: '/_authenticated/externalContent/embeds/new';
      path: '/externalContent/embeds/new';
      fullPath: '/externalContent/embeds/new';
      preLoaderRoute: typeof AuthenticatedExternalContentEmbedsNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/externalContent/links/': {
      id: '/_authenticated/externalContent/links/';
      path: '/externalContent/links';
      fullPath: '/externalContent/links/';
      preLoaderRoute: typeof AuthenticatedExternalContentLinksIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/externalContent/links/$id': {
      id: '/_authenticated/externalContent/links/$id';
      path: '/externalContent/links/$id';
      fullPath: '/externalContent/links/$id';
      preLoaderRoute: typeof AuthenticatedExternalContentLinksIdRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/externalContent/links/new': {
      id: '/_authenticated/externalContent/links/new';
      path: '/externalContent/links/new';
      fullPath: '/externalContent/links/new';
      preLoaderRoute: typeof AuthenticatedExternalContentLinksNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/externalContent/videos/': {
      id: '/_authenticated/externalContent/videos/';
      path: '/externalContent/videos';
      fullPath: '/externalContent/videos/';
      preLoaderRoute: typeof AuthenticatedExternalContentVideosIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/externalContent/videos/$id': {
      id: '/_authenticated/externalContent/videos/$id';
      path: '/externalContent/videos/$id';
      fullPath: '/externalContent/videos/$id';
      preLoaderRoute: typeof AuthenticatedExternalContentVideosIdRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/externalContent/videos/new': {
      id: '/_authenticated/externalContent/videos/new';
      path: '/externalContent/videos/new';
      fullPath: '/externalContent/videos/new';
      preLoaderRoute: typeof AuthenticatedExternalContentVideosNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/isolated/{-$scenarioName}/{-$preset}': {
      id: '/_authenticated/isolated/{-$scenarioName}/{-$preset}';
      path: '/isolated/{-$scenarioName}/{-$preset}';
      fullPath: '/isolated/{-$scenarioName}/{-$preset}';
      preLoaderRoute: typeof AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125RouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/placement/history/$metadataId': {
      id: '/_authenticated/placement/history/$metadataId';
      path: '/history/$metadataId';
      fullPath: '/placement/history/$metadataId';
      preLoaderRoute: typeof AuthenticatedPlacementHistoryMetadataIdRouteImport;
      parentRoute: typeof AuthenticatedPlacementRouteRoute;
    };
    '/_authenticated/sitemaps/$tenantId/': {
      id: '/_authenticated/sitemaps/$tenantId/';
      path: '/';
      fullPath: '/sitemaps/$tenantId/';
      preLoaderRoute: typeof AuthenticatedSitemapsTenantIdIndexRouteImport;
      parentRoute: typeof AuthenticatedSitemapsTenantIdRouteRoute;
    };
    '/_authenticated/slideshows/$id/_content': {
      id: '/_authenticated/slideshows/$id/_content';
      path: '';
      fullPath: '/slideshows/$id';
      preLoaderRoute: typeof AuthenticatedSlideshowsIdContentRouteImport;
      parentRoute: typeof AuthenticatedSlideshowsIdRouteRoute;
    };
    '/_authenticated/slideshows/$id/metadata': {
      id: '/_authenticated/slideshows/$id/metadata';
      path: '/metadata';
      fullPath: '/slideshows/$id/metadata';
      preLoaderRoute: typeof AuthenticatedSlideshowsIdMetadataRouteImport;
      parentRoute: typeof AuthenticatedSlideshowsIdRouteRoute;
    };
    '/_authenticated/slideshows/$id/push': {
      id: '/_authenticated/slideshows/$id/push';
      path: '/push';
      fullPath: '/slideshows/$id/push';
      preLoaderRoute: typeof AuthenticatedSlideshowsIdPushRouteImport;
      parentRoute: typeof AuthenticatedSlideshowsIdRouteRoute;
    };
    '/_authenticated/teams/iceHockeyTeams/': {
      id: '/_authenticated/teams/iceHockeyTeams/';
      path: '/';
      fullPath: '/teams/iceHockeyTeams/';
      preLoaderRoute: typeof AuthenticatedTeamsIceHockeyTeamsIndexRouteImport;
      parentRoute: typeof AuthenticatedTeamsIceHockeyTeamsRouteRoute;
    };
    '/_authenticated/teams/iceHockeyTeams/$id': {
      id: '/_authenticated/teams/iceHockeyTeams/$id';
      path: '/$id';
      fullPath: '/teams/iceHockeyTeams/$id';
      preLoaderRoute: typeof AuthenticatedTeamsIceHockeyTeamsIdRouteImport;
      parentRoute: typeof AuthenticatedTeamsIceHockeyTeamsRouteRoute;
    };
    '/_authenticated/teams/iceHockeyTeams/new': {
      id: '/_authenticated/teams/iceHockeyTeams/new';
      path: '/new';
      fullPath: '/teams/iceHockeyTeams/new';
      preLoaderRoute: typeof AuthenticatedTeamsIceHockeyTeamsNewRouteImport;
      parentRoute: typeof AuthenticatedTeamsIceHockeyTeamsRouteRoute;
    };
    '/_authenticated/teams/leaguesAndTournaments/': {
      id: '/_authenticated/teams/leaguesAndTournaments/';
      path: '/';
      fullPath: '/teams/leaguesAndTournaments/';
      preLoaderRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsIndexRouteImport;
      parentRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsRouteRoute;
    };
    '/_authenticated/teams/leaguesAndTournaments/$id': {
      id: '/_authenticated/teams/leaguesAndTournaments/$id';
      path: '/$id';
      fullPath: '/teams/leaguesAndTournaments/$id';
      preLoaderRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsIdRouteImport;
      parentRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsRouteRoute;
    };
    '/_authenticated/teams/leaguesAndTournaments/new': {
      id: '/_authenticated/teams/leaguesAndTournaments/new';
      path: '/new';
      fullPath: '/teams/leaguesAndTournaments/new';
      preLoaderRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsNewRouteImport;
      parentRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsRouteRoute;
    };
    '/_authenticated/teams/soccerTeams/': {
      id: '/_authenticated/teams/soccerTeams/';
      path: '/';
      fullPath: '/teams/soccerTeams/';
      preLoaderRoute: typeof AuthenticatedTeamsSoccerTeamsIndexRouteImport;
      parentRoute: typeof AuthenticatedTeamsSoccerTeamsRouteRoute;
    };
    '/_authenticated/teams/soccerTeams/$id': {
      id: '/_authenticated/teams/soccerTeams/$id';
      path: '/$id';
      fullPath: '/teams/soccerTeams/$id';
      preLoaderRoute: typeof AuthenticatedTeamsSoccerTeamsIdRouteImport;
      parentRoute: typeof AuthenticatedTeamsSoccerTeamsRouteRoute;
    };
    '/_authenticated/teams/soccerTeams/new': {
      id: '/_authenticated/teams/soccerTeams/new';
      path: '/new';
      fullPath: '/teams/soccerTeams/new';
      preLoaderRoute: typeof AuthenticatedTeamsSoccerTeamsNewRouteImport;
      parentRoute: typeof AuthenticatedTeamsSoccerTeamsRouteRoute;
    };
    '/_authenticated/teams/tennisPlayers/': {
      id: '/_authenticated/teams/tennisPlayers/';
      path: '/';
      fullPath: '/teams/tennisPlayers/';
      preLoaderRoute: typeof AuthenticatedTeamsTennisPlayersIndexRouteImport;
      parentRoute: typeof AuthenticatedTeamsTennisPlayersRouteRoute;
    };
    '/_authenticated/teams/tennisPlayers/$id': {
      id: '/_authenticated/teams/tennisPlayers/$id';
      path: '/$id';
      fullPath: '/teams/tennisPlayers/$id';
      preLoaderRoute: typeof AuthenticatedTeamsTennisPlayersIdRouteImport;
      parentRoute: typeof AuthenticatedTeamsTennisPlayersRouteRoute;
    };
    '/_authenticated/teams/tennisPlayers/new': {
      id: '/_authenticated/teams/tennisPlayers/new';
      path: '/new';
      fullPath: '/teams/tennisPlayers/new';
      preLoaderRoute: typeof AuthenticatedTeamsTennisPlayersNewRouteImport;
      parentRoute: typeof AuthenticatedTeamsTennisPlayersRouteRoute;
    };
    '/_authenticated/tickers/$id/': {
      id: '/_authenticated/tickers/$id/';
      path: '/';
      fullPath: '/tickers/$id/';
      preLoaderRoute: typeof AuthenticatedTickersIdIndexRouteImport;
      parentRoute: typeof AuthenticatedTickersIdRouteRoute;
    };
    '/_authenticated/tickers/$id/metadata': {
      id: '/_authenticated/tickers/$id/metadata';
      path: '/metadata';
      fullPath: '/tickers/$id/metadata';
      preLoaderRoute: typeof AuthenticatedTickersIdMetadataRouteImport;
      parentRoute: typeof AuthenticatedTickersIdRouteRoute;
    };
    '/_authenticated/tickers/$id/push': {
      id: '/_authenticated/tickers/$id/push';
      path: '/push';
      fullPath: '/tickers/$id/push';
      preLoaderRoute: typeof AuthenticatedTickersIdPushRouteImport;
      parentRoute: typeof AuthenticatedTickersIdRouteRoute;
    };
    '/_authenticated/articles/$id/revisions/$revisionId': {
      id: '/_authenticated/articles/$id/revisions/$revisionId';
      path: '/revisions/$revisionId';
      fullPath: '/articles/$id/revisions/$revisionId';
      preLoaderRoute: typeof AuthenticatedArticlesIdRevisionsRevisionIdRouteImport;
      parentRoute: typeof AuthenticatedArticlesIdRouteRoute;
    };
    '/_authenticated/externalContent/embeds/$id/': {
      id: '/_authenticated/externalContent/embeds/$id/';
      path: '/';
      fullPath: '/externalContent/embeds/$id/';
      preLoaderRoute: typeof AuthenticatedExternalContentEmbedsIdIndexRouteImport;
      parentRoute: typeof AuthenticatedExternalContentEmbedsIdRouteRoute;
    };
    '/_authenticated/externalContent/embeds/$id/metadata': {
      id: '/_authenticated/externalContent/embeds/$id/metadata';
      path: '/metadata';
      fullPath: '/externalContent/embeds/$id/metadata';
      preLoaderRoute: typeof AuthenticatedExternalContentEmbedsIdMetadataRouteImport;
      parentRoute: typeof AuthenticatedExternalContentEmbedsIdRouteRoute;
    };
    '/_authenticated/externalContent/embeds/$id/push': {
      id: '/_authenticated/externalContent/embeds/$id/push';
      path: '/push';
      fullPath: '/externalContent/embeds/$id/push';
      preLoaderRoute: typeof AuthenticatedExternalContentEmbedsIdPushRouteImport;
      parentRoute: typeof AuthenticatedExternalContentEmbedsIdRouteRoute;
    };
    '/_authenticated/externalContent/links/$id/': {
      id: '/_authenticated/externalContent/links/$id/';
      path: '/';
      fullPath: '/externalContent/links/$id/';
      preLoaderRoute: typeof AuthenticatedExternalContentLinksIdIndexRouteImport;
      parentRoute: typeof AuthenticatedExternalContentLinksIdRouteRoute;
    };
    '/_authenticated/externalContent/links/$id/metadata': {
      id: '/_authenticated/externalContent/links/$id/metadata';
      path: '/metadata';
      fullPath: '/externalContent/links/$id/metadata';
      preLoaderRoute: typeof AuthenticatedExternalContentLinksIdMetadataRouteImport;
      parentRoute: typeof AuthenticatedExternalContentLinksIdRouteRoute;
    };
    '/_authenticated/externalContent/links/$id/push': {
      id: '/_authenticated/externalContent/links/$id/push';
      path: '/push';
      fullPath: '/externalContent/links/$id/push';
      preLoaderRoute: typeof AuthenticatedExternalContentLinksIdPushRouteImport;
      parentRoute: typeof AuthenticatedExternalContentLinksIdRouteRoute;
    };
    '/_authenticated/externalContent/videos/$id/': {
      id: '/_authenticated/externalContent/videos/$id/';
      path: '/';
      fullPath: '/externalContent/videos/$id/';
      preLoaderRoute: typeof AuthenticatedExternalContentVideosIdIndexRouteImport;
      parentRoute: typeof AuthenticatedExternalContentVideosIdRouteRoute;
    };
    '/_authenticated/externalContent/videos/$id/metadata': {
      id: '/_authenticated/externalContent/videos/$id/metadata';
      path: '/metadata';
      fullPath: '/externalContent/videos/$id/metadata';
      preLoaderRoute: typeof AuthenticatedExternalContentVideosIdMetadataRouteImport;
      parentRoute: typeof AuthenticatedExternalContentVideosIdRouteRoute;
    };
    '/_authenticated/externalContent/videos/$id/push': {
      id: '/_authenticated/externalContent/videos/$id/push';
      path: '/push';
      fullPath: '/externalContent/videos/$id/push';
      preLoaderRoute: typeof AuthenticatedExternalContentVideosIdPushRouteImport;
      parentRoute: typeof AuthenticatedExternalContentVideosIdRouteRoute;
    };
    '/_authenticated/preview/metadata/$metadataId/{-$tenantId}': {
      id: '/_authenticated/preview/metadata/$metadataId/{-$tenantId}';
      path: '/preview/metadata/$metadataId/{-$tenantId}';
      fullPath: '/preview/metadata/$metadataId/{-$tenantId}';
      preLoaderRoute: typeof AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125RouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/preview/placement/$sectionId/$tenantId': {
      id: '/_authenticated/preview/placement/$sectionId/$tenantId';
      path: '/preview/placement/$sectionId/$tenantId';
      fullPath: '/preview/placement/$sectionId/$tenantId';
      preLoaderRoute: typeof AuthenticatedPreviewPlacementSectionIdTenantIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/sitemaps/$tenantId/nodes/$sitemapNodeId': {
      id: '/_authenticated/sitemaps/$tenantId/nodes/$sitemapNodeId';
      path: '/nodes/$sitemapNodeId';
      fullPath: '/sitemaps/$tenantId/nodes/$sitemapNodeId';
      preLoaderRoute: typeof AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRouteImport;
      parentRoute: typeof AuthenticatedSitemapsTenantIdRouteRoute;
    };
    '/_authenticated/sitemaps/$tenantId/nodes/new': {
      id: '/_authenticated/sitemaps/$tenantId/nodes/new';
      path: '/nodes/new';
      fullPath: '/sitemaps/$tenantId/nodes/new';
      preLoaderRoute: typeof AuthenticatedSitemapsTenantIdNodesNewRouteImport;
      parentRoute: typeof AuthenticatedSitemapsTenantIdRouteRoute;
    };
    '/_authenticated/slideshows/$id/_content/': {
      id: '/_authenticated/slideshows/$id/_content/';
      path: '/';
      fullPath: '/slideshows/$id/';
      preLoaderRoute: typeof AuthenticatedSlideshowsIdContentIndexRouteImport;
      parentRoute: typeof AuthenticatedSlideshowsIdContentRoute;
    };
    '/_authenticated/placement/$tenantId/category/$categoryId/sections': {
      id: '/_authenticated/placement/$tenantId/category/$categoryId/sections';
      path: '/$tenantId/category/$categoryId/sections';
      fullPath: '/placement/$tenantId/category/$categoryId/sections';
      preLoaderRoute: typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteImport;
      parentRoute: typeof AuthenticatedPlacementRouteRoute;
    };
    '/_authenticated/placement/$tenantId/tag/$tagId/sections': {
      id: '/_authenticated/placement/$tenantId/tag/$tagId/sections';
      path: '/$tenantId/tag/$tagId/sections';
      fullPath: '/placement/$tenantId/tag/$tagId/sections';
      preLoaderRoute: typeof AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteImport;
      parentRoute: typeof AuthenticatedPlacementRouteRoute;
    };
    '/_authenticated/slideshows/$id/_content/slides/$slideId': {
      id: '/_authenticated/slideshows/$id/_content/slides/$slideId';
      path: '/slides/$slideId';
      fullPath: '/slideshows/$id/slides/$slideId';
      preLoaderRoute: typeof AuthenticatedSlideshowsIdContentSlidesSlideIdRouteImport;
      parentRoute: typeof AuthenticatedSlideshowsIdContentRoute;
    };
    '/_authenticated/slideshows/$id/_content/slides/bulk': {
      id: '/_authenticated/slideshows/$id/_content/slides/bulk';
      path: '/slides/bulk';
      fullPath: '/slideshows/$id/slides/bulk';
      preLoaderRoute: typeof AuthenticatedSlideshowsIdContentSlidesBulkRouteImport;
      parentRoute: typeof AuthenticatedSlideshowsIdContentRoute;
    };
    '/_authenticated/placement/$tenantId/category/$categoryId/sections/$sectionId': {
      id: '/_authenticated/placement/$tenantId/category/$categoryId/sections/$sectionId';
      path: '/$sectionId';
      fullPath: '/placement/$tenantId/category/$categoryId/sections/$sectionId';
      preLoaderRoute: typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRouteImport;
      parentRoute: typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRoute;
    };
    '/_authenticated/placement/$tenantId/category/$categoryId/sections/new': {
      id: '/_authenticated/placement/$tenantId/category/$categoryId/sections/new';
      path: '/new';
      fullPath: '/placement/$tenantId/category/$categoryId/sections/new';
      preLoaderRoute: typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRouteImport;
      parentRoute: typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRoute;
    };
    '/_authenticated/placement/$tenantId/tag/$tagId/sections/$sectionId': {
      id: '/_authenticated/placement/$tenantId/tag/$tagId/sections/$sectionId';
      path: '/$sectionId';
      fullPath: '/placement/$tenantId/tag/$tagId/sections/$sectionId';
      preLoaderRoute: typeof AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRouteImport;
      parentRoute: typeof AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRoute;
    };
    '/_authenticated/placement/$tenantId/tag/$tagId/sections/new': {
      id: '/_authenticated/placement/$tenantId/tag/$tagId/sections/new';
      path: '/new';
      fullPath: '/placement/$tenantId/tag/$tagId/sections/new';
      preLoaderRoute: typeof AuthenticatedPlacementTenantIdTagTagIdSectionsNewRouteImport;
      parentRoute: typeof AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRoute;
    };
  }
}

interface AuthenticatedCategoriesRouteRouteChildren {
  AuthenticatedCategoriesIdRoute: typeof AuthenticatedCategoriesIdRoute;
  AuthenticatedCategoriesNewRoute: typeof AuthenticatedCategoriesNewRoute;
  AuthenticatedCategoriesIndexRoute: typeof AuthenticatedCategoriesIndexRoute;
}

const AuthenticatedCategoriesRouteRouteChildren: AuthenticatedCategoriesRouteRouteChildren =
  {
    AuthenticatedCategoriesIdRoute: AuthenticatedCategoriesIdRoute,
    AuthenticatedCategoriesNewRoute: AuthenticatedCategoriesNewRoute,
    AuthenticatedCategoriesIndexRoute: AuthenticatedCategoriesIndexRoute,
  };

const AuthenticatedCategoriesRouteRouteWithChildren =
  AuthenticatedCategoriesRouteRoute._addFileChildren(
    AuthenticatedCategoriesRouteRouteChildren,
  );

interface AuthenticatedCollectionsRouteRouteChildren {
  AuthenticatedCollectionsCollectionIdRoute: typeof AuthenticatedCollectionsCollectionIdRoute;
  AuthenticatedCollectionsIndexRoute: typeof AuthenticatedCollectionsIndexRoute;
}

const AuthenticatedCollectionsRouteRouteChildren: AuthenticatedCollectionsRouteRouteChildren =
  {
    AuthenticatedCollectionsCollectionIdRoute:
      AuthenticatedCollectionsCollectionIdRoute,
    AuthenticatedCollectionsIndexRoute: AuthenticatedCollectionsIndexRoute,
  };

const AuthenticatedCollectionsRouteRouteWithChildren =
  AuthenticatedCollectionsRouteRoute._addFileChildren(
    AuthenticatedCollectionsRouteRouteChildren,
  );

interface AuthenticatedGeneeaEntitiesRouteRouteChildren {
  AuthenticatedGeneeaEntitiesIdRoute: typeof AuthenticatedGeneeaEntitiesIdRoute;
  AuthenticatedGeneeaEntitiesIndexRoute: typeof AuthenticatedGeneeaEntitiesIndexRoute;
}

const AuthenticatedGeneeaEntitiesRouteRouteChildren: AuthenticatedGeneeaEntitiesRouteRouteChildren =
  {
    AuthenticatedGeneeaEntitiesIdRoute: AuthenticatedGeneeaEntitiesIdRoute,
    AuthenticatedGeneeaEntitiesIndexRoute:
      AuthenticatedGeneeaEntitiesIndexRoute,
  };

const AuthenticatedGeneeaEntitiesRouteRouteWithChildren =
  AuthenticatedGeneeaEntitiesRouteRoute._addFileChildren(
    AuthenticatedGeneeaEntitiesRouteRouteChildren,
  );

interface AuthenticatedKickwordsRouteRouteChildren {
  AuthenticatedKickwordsIdRoute: typeof AuthenticatedKickwordsIdRoute;
  AuthenticatedKickwordsNewRoute: typeof AuthenticatedKickwordsNewRoute;
  AuthenticatedKickwordsIndexRoute: typeof AuthenticatedKickwordsIndexRoute;
}

const AuthenticatedKickwordsRouteRouteChildren: AuthenticatedKickwordsRouteRouteChildren =
  {
    AuthenticatedKickwordsIdRoute: AuthenticatedKickwordsIdRoute,
    AuthenticatedKickwordsNewRoute: AuthenticatedKickwordsNewRoute,
    AuthenticatedKickwordsIndexRoute: AuthenticatedKickwordsIndexRoute,
  };

const AuthenticatedKickwordsRouteRouteWithChildren =
  AuthenticatedKickwordsRouteRoute._addFileChildren(
    AuthenticatedKickwordsRouteRouteChildren,
  );

interface AuthenticatedNewslettersRouteRouteChildren {
  AuthenticatedNewslettersIdRoute: typeof AuthenticatedNewslettersIdRoute;
  AuthenticatedNewslettersIndexRoute: typeof AuthenticatedNewslettersIndexRoute;
}

const AuthenticatedNewslettersRouteRouteChildren: AuthenticatedNewslettersRouteRouteChildren =
  {
    AuthenticatedNewslettersIdRoute: AuthenticatedNewslettersIdRoute,
    AuthenticatedNewslettersIndexRoute: AuthenticatedNewslettersIndexRoute,
  };

const AuthenticatedNewslettersRouteRouteWithChildren =
  AuthenticatedNewslettersRouteRoute._addFileChildren(
    AuthenticatedNewslettersRouteRouteChildren,
  );

interface AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteChildren {
  AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRoute: typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRoute;
  AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRoute: typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRoute;
}

const AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteChildren: AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteChildren =
  {
    AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRoute:
      AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsSectionIdRoute,
    AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRoute:
      AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsNewRoute,
  };

const AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteWithChildren =
  AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRoute._addFileChildren(
    AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteChildren,
  );

interface AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteChildren {
  AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRoute: typeof AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRoute;
  AuthenticatedPlacementTenantIdTagTagIdSectionsNewRoute: typeof AuthenticatedPlacementTenantIdTagTagIdSectionsNewRoute;
}

const AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteChildren: AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteChildren =
  {
    AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRoute:
      AuthenticatedPlacementTenantIdTagTagIdSectionsSectionIdRoute,
    AuthenticatedPlacementTenantIdTagTagIdSectionsNewRoute:
      AuthenticatedPlacementTenantIdTagTagIdSectionsNewRoute,
  };

const AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteWithChildren =
  AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRoute._addFileChildren(
    AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteChildren,
  );

interface AuthenticatedPlacementRouteRouteChildren {
  AuthenticatedPlacementIndexRoute: typeof AuthenticatedPlacementIndexRoute;
  AuthenticatedPlacementHistoryMetadataIdRoute: typeof AuthenticatedPlacementHistoryMetadataIdRoute;
  AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRoute: typeof AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteWithChildren;
  AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRoute: typeof AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteWithChildren;
}

const AuthenticatedPlacementRouteRouteChildren: AuthenticatedPlacementRouteRouteChildren =
  {
    AuthenticatedPlacementIndexRoute: AuthenticatedPlacementIndexRoute,
    AuthenticatedPlacementHistoryMetadataIdRoute:
      AuthenticatedPlacementHistoryMetadataIdRoute,
    AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRoute:
      AuthenticatedPlacementTenantIdCategoryCategoryIdSectionsRouteRouteWithChildren,
    AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRoute:
      AuthenticatedPlacementTenantIdTagTagIdSectionsRouteRouteWithChildren,
  };

const AuthenticatedPlacementRouteRouteWithChildren =
  AuthenticatedPlacementRouteRoute._addFileChildren(
    AuthenticatedPlacementRouteRouteChildren,
  );

interface AuthenticatedReleasenotesRouteRouteChildren {
  AuthenticatedReleasenotesIdRoute: typeof AuthenticatedReleasenotesIdRoute;
  AuthenticatedReleasenotesNewRoute: typeof AuthenticatedReleasenotesNewRoute;
  AuthenticatedReleasenotesIndexRoute: typeof AuthenticatedReleasenotesIndexRoute;
}

const AuthenticatedReleasenotesRouteRouteChildren: AuthenticatedReleasenotesRouteRouteChildren =
  {
    AuthenticatedReleasenotesIdRoute: AuthenticatedReleasenotesIdRoute,
    AuthenticatedReleasenotesNewRoute: AuthenticatedReleasenotesNewRoute,
    AuthenticatedReleasenotesIndexRoute: AuthenticatedReleasenotesIndexRoute,
  };

const AuthenticatedReleasenotesRouteRouteWithChildren =
  AuthenticatedReleasenotesRouteRoute._addFileChildren(
    AuthenticatedReleasenotesRouteRouteChildren,
  );

interface AuthenticatedRtelementsRouteRouteChildren {
  AuthenticatedRtelementsElementIdRoute: typeof AuthenticatedRtelementsElementIdRoute;
  AuthenticatedRtelementsNewRoute: typeof AuthenticatedRtelementsNewRoute;
  AuthenticatedRtelementsIndexRoute: typeof AuthenticatedRtelementsIndexRoute;
}

const AuthenticatedRtelementsRouteRouteChildren: AuthenticatedRtelementsRouteRouteChildren =
  {
    AuthenticatedRtelementsElementIdRoute:
      AuthenticatedRtelementsElementIdRoute,
    AuthenticatedRtelementsNewRoute: AuthenticatedRtelementsNewRoute,
    AuthenticatedRtelementsIndexRoute: AuthenticatedRtelementsIndexRoute,
  };

const AuthenticatedRtelementsRouteRouteWithChildren =
  AuthenticatedRtelementsRouteRoute._addFileChildren(
    AuthenticatedRtelementsRouteRouteChildren,
  );

interface AuthenticatedSitemapsTenantIdRouteRouteChildren {
  AuthenticatedSitemapsTenantIdIndexRoute: typeof AuthenticatedSitemapsTenantIdIndexRoute;
  AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRoute: typeof AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRoute;
  AuthenticatedSitemapsTenantIdNodesNewRoute: typeof AuthenticatedSitemapsTenantIdNodesNewRoute;
}

const AuthenticatedSitemapsTenantIdRouteRouteChildren: AuthenticatedSitemapsTenantIdRouteRouteChildren =
  {
    AuthenticatedSitemapsTenantIdIndexRoute:
      AuthenticatedSitemapsTenantIdIndexRoute,
    AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRoute:
      AuthenticatedSitemapsTenantIdNodesSitemapNodeIdRoute,
    AuthenticatedSitemapsTenantIdNodesNewRoute:
      AuthenticatedSitemapsTenantIdNodesNewRoute,
  };

const AuthenticatedSitemapsTenantIdRouteRouteWithChildren =
  AuthenticatedSitemapsTenantIdRouteRoute._addFileChildren(
    AuthenticatedSitemapsTenantIdRouteRouteChildren,
  );

interface AuthenticatedSitemapsRouteRouteChildren {
  AuthenticatedSitemapsTenantIdRouteRoute: typeof AuthenticatedSitemapsTenantIdRouteRouteWithChildren;
  AuthenticatedSitemapsIndexRoute: typeof AuthenticatedSitemapsIndexRoute;
}

const AuthenticatedSitemapsRouteRouteChildren: AuthenticatedSitemapsRouteRouteChildren =
  {
    AuthenticatedSitemapsTenantIdRouteRoute:
      AuthenticatedSitemapsTenantIdRouteRouteWithChildren,
    AuthenticatedSitemapsIndexRoute: AuthenticatedSitemapsIndexRoute,
  };

const AuthenticatedSitemapsRouteRouteWithChildren =
  AuthenticatedSitemapsRouteRoute._addFileChildren(
    AuthenticatedSitemapsRouteRouteChildren,
  );

interface AuthenticatedTagsRouteRouteChildren {
  AuthenticatedTagsIdRoute: typeof AuthenticatedTagsIdRoute;
  AuthenticatedTagsNewRoute: typeof AuthenticatedTagsNewRoute;
  AuthenticatedTagsIndexRoute: typeof AuthenticatedTagsIndexRoute;
}

const AuthenticatedTagsRouteRouteChildren: AuthenticatedTagsRouteRouteChildren =
  {
    AuthenticatedTagsIdRoute: AuthenticatedTagsIdRoute,
    AuthenticatedTagsNewRoute: AuthenticatedTagsNewRoute,
    AuthenticatedTagsIndexRoute: AuthenticatedTagsIndexRoute,
  };

const AuthenticatedTagsRouteRouteWithChildren =
  AuthenticatedTagsRouteRoute._addFileChildren(
    AuthenticatedTagsRouteRouteChildren,
  );

interface AuthenticatedTeamsIceHockeyTeamsRouteRouteChildren {
  AuthenticatedTeamsIceHockeyTeamsIdRoute: typeof AuthenticatedTeamsIceHockeyTeamsIdRoute;
  AuthenticatedTeamsIceHockeyTeamsNewRoute: typeof AuthenticatedTeamsIceHockeyTeamsNewRoute;
  AuthenticatedTeamsIceHockeyTeamsIndexRoute: typeof AuthenticatedTeamsIceHockeyTeamsIndexRoute;
}

const AuthenticatedTeamsIceHockeyTeamsRouteRouteChildren: AuthenticatedTeamsIceHockeyTeamsRouteRouteChildren =
  {
    AuthenticatedTeamsIceHockeyTeamsIdRoute:
      AuthenticatedTeamsIceHockeyTeamsIdRoute,
    AuthenticatedTeamsIceHockeyTeamsNewRoute:
      AuthenticatedTeamsIceHockeyTeamsNewRoute,
    AuthenticatedTeamsIceHockeyTeamsIndexRoute:
      AuthenticatedTeamsIceHockeyTeamsIndexRoute,
  };

const AuthenticatedTeamsIceHockeyTeamsRouteRouteWithChildren =
  AuthenticatedTeamsIceHockeyTeamsRouteRoute._addFileChildren(
    AuthenticatedTeamsIceHockeyTeamsRouteRouteChildren,
  );

interface AuthenticatedTeamsLeaguesAndTournamentsRouteRouteChildren {
  AuthenticatedTeamsLeaguesAndTournamentsIdRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsIdRoute;
  AuthenticatedTeamsLeaguesAndTournamentsNewRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsNewRoute;
  AuthenticatedTeamsLeaguesAndTournamentsIndexRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsIndexRoute;
}

const AuthenticatedTeamsLeaguesAndTournamentsRouteRouteChildren: AuthenticatedTeamsLeaguesAndTournamentsRouteRouteChildren =
  {
    AuthenticatedTeamsLeaguesAndTournamentsIdRoute:
      AuthenticatedTeamsLeaguesAndTournamentsIdRoute,
    AuthenticatedTeamsLeaguesAndTournamentsNewRoute:
      AuthenticatedTeamsLeaguesAndTournamentsNewRoute,
    AuthenticatedTeamsLeaguesAndTournamentsIndexRoute:
      AuthenticatedTeamsLeaguesAndTournamentsIndexRoute,
  };

const AuthenticatedTeamsLeaguesAndTournamentsRouteRouteWithChildren =
  AuthenticatedTeamsLeaguesAndTournamentsRouteRoute._addFileChildren(
    AuthenticatedTeamsLeaguesAndTournamentsRouteRouteChildren,
  );

interface AuthenticatedTeamsSoccerTeamsRouteRouteChildren {
  AuthenticatedTeamsSoccerTeamsIdRoute: typeof AuthenticatedTeamsSoccerTeamsIdRoute;
  AuthenticatedTeamsSoccerTeamsNewRoute: typeof AuthenticatedTeamsSoccerTeamsNewRoute;
  AuthenticatedTeamsSoccerTeamsIndexRoute: typeof AuthenticatedTeamsSoccerTeamsIndexRoute;
}

const AuthenticatedTeamsSoccerTeamsRouteRouteChildren: AuthenticatedTeamsSoccerTeamsRouteRouteChildren =
  {
    AuthenticatedTeamsSoccerTeamsIdRoute: AuthenticatedTeamsSoccerTeamsIdRoute,
    AuthenticatedTeamsSoccerTeamsNewRoute:
      AuthenticatedTeamsSoccerTeamsNewRoute,
    AuthenticatedTeamsSoccerTeamsIndexRoute:
      AuthenticatedTeamsSoccerTeamsIndexRoute,
  };

const AuthenticatedTeamsSoccerTeamsRouteRouteWithChildren =
  AuthenticatedTeamsSoccerTeamsRouteRoute._addFileChildren(
    AuthenticatedTeamsSoccerTeamsRouteRouteChildren,
  );

interface AuthenticatedTeamsTennisPlayersRouteRouteChildren {
  AuthenticatedTeamsTennisPlayersIdRoute: typeof AuthenticatedTeamsTennisPlayersIdRoute;
  AuthenticatedTeamsTennisPlayersNewRoute: typeof AuthenticatedTeamsTennisPlayersNewRoute;
  AuthenticatedTeamsTennisPlayersIndexRoute: typeof AuthenticatedTeamsTennisPlayersIndexRoute;
}

const AuthenticatedTeamsTennisPlayersRouteRouteChildren: AuthenticatedTeamsTennisPlayersRouteRouteChildren =
  {
    AuthenticatedTeamsTennisPlayersIdRoute:
      AuthenticatedTeamsTennisPlayersIdRoute,
    AuthenticatedTeamsTennisPlayersNewRoute:
      AuthenticatedTeamsTennisPlayersNewRoute,
    AuthenticatedTeamsTennisPlayersIndexRoute:
      AuthenticatedTeamsTennisPlayersIndexRoute,
  };

const AuthenticatedTeamsTennisPlayersRouteRouteWithChildren =
  AuthenticatedTeamsTennisPlayersRouteRoute._addFileChildren(
    AuthenticatedTeamsTennisPlayersRouteRouteChildren,
  );

interface AuthenticatedTeamsRouteRouteChildren {
  AuthenticatedTeamsIceHockeyTeamsRouteRoute: typeof AuthenticatedTeamsIceHockeyTeamsRouteRouteWithChildren;
  AuthenticatedTeamsLeaguesAndTournamentsRouteRoute: typeof AuthenticatedTeamsLeaguesAndTournamentsRouteRouteWithChildren;
  AuthenticatedTeamsSoccerTeamsRouteRoute: typeof AuthenticatedTeamsSoccerTeamsRouteRouteWithChildren;
  AuthenticatedTeamsTennisPlayersRouteRoute: typeof AuthenticatedTeamsTennisPlayersRouteRouteWithChildren;
  AuthenticatedTeamsIndexRoute: typeof AuthenticatedTeamsIndexRoute;
}

const AuthenticatedTeamsRouteRouteChildren: AuthenticatedTeamsRouteRouteChildren =
  {
    AuthenticatedTeamsIceHockeyTeamsRouteRoute:
      AuthenticatedTeamsIceHockeyTeamsRouteRouteWithChildren,
    AuthenticatedTeamsLeaguesAndTournamentsRouteRoute:
      AuthenticatedTeamsLeaguesAndTournamentsRouteRouteWithChildren,
    AuthenticatedTeamsSoccerTeamsRouteRoute:
      AuthenticatedTeamsSoccerTeamsRouteRouteWithChildren,
    AuthenticatedTeamsTennisPlayersRouteRoute:
      AuthenticatedTeamsTennisPlayersRouteRouteWithChildren,
    AuthenticatedTeamsIndexRoute: AuthenticatedTeamsIndexRoute,
  };

const AuthenticatedTeamsRouteRouteWithChildren =
  AuthenticatedTeamsRouteRoute._addFileChildren(
    AuthenticatedTeamsRouteRouteChildren,
  );

interface AuthenticatedUsersRouteRouteChildren {
  AuthenticatedUsersIdRoute: typeof AuthenticatedUsersIdRoute;
  AuthenticatedUsersNewRoute: typeof AuthenticatedUsersNewRoute;
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute;
}

const AuthenticatedUsersRouteRouteChildren: AuthenticatedUsersRouteRouteChildren =
  {
    AuthenticatedUsersIdRoute: AuthenticatedUsersIdRoute,
    AuthenticatedUsersNewRoute: AuthenticatedUsersNewRoute,
    AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  };

const AuthenticatedUsersRouteRouteWithChildren =
  AuthenticatedUsersRouteRoute._addFileChildren(
    AuthenticatedUsersRouteRouteChildren,
  );

interface AuthenticatedArticlesIdRouteRouteChildren {
  AuthenticatedArticlesIdMetadataRoute: typeof AuthenticatedArticlesIdMetadataRoute;
  AuthenticatedArticlesIdPushRoute: typeof AuthenticatedArticlesIdPushRoute;
  AuthenticatedArticlesIdIndexRoute: typeof AuthenticatedArticlesIdIndexRoute;
  AuthenticatedArticlesIdRevisionsRevisionIdRoute: typeof AuthenticatedArticlesIdRevisionsRevisionIdRoute;
}

const AuthenticatedArticlesIdRouteRouteChildren: AuthenticatedArticlesIdRouteRouteChildren =
  {
    AuthenticatedArticlesIdMetadataRoute: AuthenticatedArticlesIdMetadataRoute,
    AuthenticatedArticlesIdPushRoute: AuthenticatedArticlesIdPushRoute,
    AuthenticatedArticlesIdIndexRoute: AuthenticatedArticlesIdIndexRoute,
    AuthenticatedArticlesIdRevisionsRevisionIdRoute:
      AuthenticatedArticlesIdRevisionsRevisionIdRoute,
  };

const AuthenticatedArticlesIdRouteRouteWithChildren =
  AuthenticatedArticlesIdRouteRoute._addFileChildren(
    AuthenticatedArticlesIdRouteRouteChildren,
  );

interface AuthenticatedBreakingnewsIdRouteRouteChildren {
  AuthenticatedBreakingnewsIdMetadataRoute: typeof AuthenticatedBreakingnewsIdMetadataRoute;
  AuthenticatedBreakingnewsIdPushRoute: typeof AuthenticatedBreakingnewsIdPushRoute;
  AuthenticatedBreakingnewsIdIndexRoute: typeof AuthenticatedBreakingnewsIdIndexRoute;
}

const AuthenticatedBreakingnewsIdRouteRouteChildren: AuthenticatedBreakingnewsIdRouteRouteChildren =
  {
    AuthenticatedBreakingnewsIdMetadataRoute:
      AuthenticatedBreakingnewsIdMetadataRoute,
    AuthenticatedBreakingnewsIdPushRoute: AuthenticatedBreakingnewsIdPushRoute,
    AuthenticatedBreakingnewsIdIndexRoute:
      AuthenticatedBreakingnewsIdIndexRoute,
  };

const AuthenticatedBreakingnewsIdRouteRouteWithChildren =
  AuthenticatedBreakingnewsIdRouteRoute._addFileChildren(
    AuthenticatedBreakingnewsIdRouteRouteChildren,
  );

interface AuthenticatedSlideshowsIdContentRouteChildren {
  AuthenticatedSlideshowsIdContentIndexRoute: typeof AuthenticatedSlideshowsIdContentIndexRoute;
  AuthenticatedSlideshowsIdContentSlidesSlideIdRoute: typeof AuthenticatedSlideshowsIdContentSlidesSlideIdRoute;
  AuthenticatedSlideshowsIdContentSlidesBulkRoute: typeof AuthenticatedSlideshowsIdContentSlidesBulkRoute;
}

const AuthenticatedSlideshowsIdContentRouteChildren: AuthenticatedSlideshowsIdContentRouteChildren =
  {
    AuthenticatedSlideshowsIdContentIndexRoute:
      AuthenticatedSlideshowsIdContentIndexRoute,
    AuthenticatedSlideshowsIdContentSlidesSlideIdRoute:
      AuthenticatedSlideshowsIdContentSlidesSlideIdRoute,
    AuthenticatedSlideshowsIdContentSlidesBulkRoute:
      AuthenticatedSlideshowsIdContentSlidesBulkRoute,
  };

const AuthenticatedSlideshowsIdContentRouteWithChildren =
  AuthenticatedSlideshowsIdContentRoute._addFileChildren(
    AuthenticatedSlideshowsIdContentRouteChildren,
  );

interface AuthenticatedSlideshowsIdRouteRouteChildren {
  AuthenticatedSlideshowsIdContentRoute: typeof AuthenticatedSlideshowsIdContentRouteWithChildren;
  AuthenticatedSlideshowsIdMetadataRoute: typeof AuthenticatedSlideshowsIdMetadataRoute;
  AuthenticatedSlideshowsIdPushRoute: typeof AuthenticatedSlideshowsIdPushRoute;
}

const AuthenticatedSlideshowsIdRouteRouteChildren: AuthenticatedSlideshowsIdRouteRouteChildren =
  {
    AuthenticatedSlideshowsIdContentRoute:
      AuthenticatedSlideshowsIdContentRouteWithChildren,
    AuthenticatedSlideshowsIdMetadataRoute:
      AuthenticatedSlideshowsIdMetadataRoute,
    AuthenticatedSlideshowsIdPushRoute: AuthenticatedSlideshowsIdPushRoute,
  };

const AuthenticatedSlideshowsIdRouteRouteWithChildren =
  AuthenticatedSlideshowsIdRouteRoute._addFileChildren(
    AuthenticatedSlideshowsIdRouteRouteChildren,
  );

interface AuthenticatedTickersIdRouteRouteChildren {
  AuthenticatedTickersIdMetadataRoute: typeof AuthenticatedTickersIdMetadataRoute;
  AuthenticatedTickersIdPushRoute: typeof AuthenticatedTickersIdPushRoute;
  AuthenticatedTickersIdIndexRoute: typeof AuthenticatedTickersIdIndexRoute;
}

const AuthenticatedTickersIdRouteRouteChildren: AuthenticatedTickersIdRouteRouteChildren =
  {
    AuthenticatedTickersIdMetadataRoute: AuthenticatedTickersIdMetadataRoute,
    AuthenticatedTickersIdPushRoute: AuthenticatedTickersIdPushRoute,
    AuthenticatedTickersIdIndexRoute: AuthenticatedTickersIdIndexRoute,
  };

const AuthenticatedTickersIdRouteRouteWithChildren =
  AuthenticatedTickersIdRouteRoute._addFileChildren(
    AuthenticatedTickersIdRouteRouteChildren,
  );

interface AuthenticatedExternalContentEmbedsIdRouteRouteChildren {
  AuthenticatedExternalContentEmbedsIdMetadataRoute: typeof AuthenticatedExternalContentEmbedsIdMetadataRoute;
  AuthenticatedExternalContentEmbedsIdPushRoute: typeof AuthenticatedExternalContentEmbedsIdPushRoute;
  AuthenticatedExternalContentEmbedsIdIndexRoute: typeof AuthenticatedExternalContentEmbedsIdIndexRoute;
}

const AuthenticatedExternalContentEmbedsIdRouteRouteChildren: AuthenticatedExternalContentEmbedsIdRouteRouteChildren =
  {
    AuthenticatedExternalContentEmbedsIdMetadataRoute:
      AuthenticatedExternalContentEmbedsIdMetadataRoute,
    AuthenticatedExternalContentEmbedsIdPushRoute:
      AuthenticatedExternalContentEmbedsIdPushRoute,
    AuthenticatedExternalContentEmbedsIdIndexRoute:
      AuthenticatedExternalContentEmbedsIdIndexRoute,
  };

const AuthenticatedExternalContentEmbedsIdRouteRouteWithChildren =
  AuthenticatedExternalContentEmbedsIdRouteRoute._addFileChildren(
    AuthenticatedExternalContentEmbedsIdRouteRouteChildren,
  );

interface AuthenticatedExternalContentLinksIdRouteRouteChildren {
  AuthenticatedExternalContentLinksIdMetadataRoute: typeof AuthenticatedExternalContentLinksIdMetadataRoute;
  AuthenticatedExternalContentLinksIdPushRoute: typeof AuthenticatedExternalContentLinksIdPushRoute;
  AuthenticatedExternalContentLinksIdIndexRoute: typeof AuthenticatedExternalContentLinksIdIndexRoute;
}

const AuthenticatedExternalContentLinksIdRouteRouteChildren: AuthenticatedExternalContentLinksIdRouteRouteChildren =
  {
    AuthenticatedExternalContentLinksIdMetadataRoute:
      AuthenticatedExternalContentLinksIdMetadataRoute,
    AuthenticatedExternalContentLinksIdPushRoute:
      AuthenticatedExternalContentLinksIdPushRoute,
    AuthenticatedExternalContentLinksIdIndexRoute:
      AuthenticatedExternalContentLinksIdIndexRoute,
  };

const AuthenticatedExternalContentLinksIdRouteRouteWithChildren =
  AuthenticatedExternalContentLinksIdRouteRoute._addFileChildren(
    AuthenticatedExternalContentLinksIdRouteRouteChildren,
  );

interface AuthenticatedExternalContentVideosIdRouteRouteChildren {
  AuthenticatedExternalContentVideosIdMetadataRoute: typeof AuthenticatedExternalContentVideosIdMetadataRoute;
  AuthenticatedExternalContentVideosIdPushRoute: typeof AuthenticatedExternalContentVideosIdPushRoute;
  AuthenticatedExternalContentVideosIdIndexRoute: typeof AuthenticatedExternalContentVideosIdIndexRoute;
}

const AuthenticatedExternalContentVideosIdRouteRouteChildren: AuthenticatedExternalContentVideosIdRouteRouteChildren =
  {
    AuthenticatedExternalContentVideosIdMetadataRoute:
      AuthenticatedExternalContentVideosIdMetadataRoute,
    AuthenticatedExternalContentVideosIdPushRoute:
      AuthenticatedExternalContentVideosIdPushRoute,
    AuthenticatedExternalContentVideosIdIndexRoute:
      AuthenticatedExternalContentVideosIdIndexRoute,
  };

const AuthenticatedExternalContentVideosIdRouteRouteWithChildren =
  AuthenticatedExternalContentVideosIdRouteRoute._addFileChildren(
    AuthenticatedExternalContentVideosIdRouteRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedCategoriesRouteRoute: typeof AuthenticatedCategoriesRouteRouteWithChildren;
  AuthenticatedCollectionsRouteRoute: typeof AuthenticatedCollectionsRouteRouteWithChildren;
  AuthenticatedGeneeaEntitiesRouteRoute: typeof AuthenticatedGeneeaEntitiesRouteRouteWithChildren;
  AuthenticatedKickwordsRouteRoute: typeof AuthenticatedKickwordsRouteRouteWithChildren;
  AuthenticatedNewslettersRouteRoute: typeof AuthenticatedNewslettersRouteRouteWithChildren;
  AuthenticatedPlacementRouteRoute: typeof AuthenticatedPlacementRouteRouteWithChildren;
  AuthenticatedReleasenotesRouteRoute: typeof AuthenticatedReleasenotesRouteRouteWithChildren;
  AuthenticatedRtelementsRouteRoute: typeof AuthenticatedRtelementsRouteRouteWithChildren;
  AuthenticatedSitemapsRouteRoute: typeof AuthenticatedSitemapsRouteRouteWithChildren;
  AuthenticatedTagsRouteRoute: typeof AuthenticatedTagsRouteRouteWithChildren;
  AuthenticatedTeamsRouteRoute: typeof AuthenticatedTeamsRouteRouteWithChildren;
  AuthenticatedUsersRouteRoute: typeof AuthenticatedUsersRouteRouteWithChildren;
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute;
  AuthenticatedArticlesIdRouteRoute: typeof AuthenticatedArticlesIdRouteRouteWithChildren;
  AuthenticatedBreakingnewsIdRouteRoute: typeof AuthenticatedBreakingnewsIdRouteRouteWithChildren;
  AuthenticatedSlideshowsIdRouteRoute: typeof AuthenticatedSlideshowsIdRouteRouteWithChildren;
  AuthenticatedTickersIdRouteRoute: typeof AuthenticatedTickersIdRouteRouteWithChildren;
  AuthenticatedArticlesNewRoute: typeof AuthenticatedArticlesNewRoute;
  AuthenticatedBreakingnewsNewRoute: typeof AuthenticatedBreakingnewsNewRoute;
  AuthenticatedMaintenancenotesIdRoute: typeof AuthenticatedMaintenancenotesIdRoute;
  AuthenticatedSlideshowsNewRoute: typeof AuthenticatedSlideshowsNewRoute;
  AuthenticatedTickersNewRoute: typeof AuthenticatedTickersNewRoute;
  AuthenticatedhomeIndexRoute: typeof AuthenticatedhomeIndexRoute;
  AuthenticatedArticlesIndexRoute: typeof AuthenticatedArticlesIndexRoute;
  AuthenticatedBreakingnewsIndexRoute: typeof AuthenticatedBreakingnewsIndexRoute;
  AuthenticatedCuratedListIndexRoute: typeof AuthenticatedCuratedListIndexRoute;
  AuthenticatedPlateIndexRoute: typeof AuthenticatedPlateIndexRoute;
  AuthenticatedSlideshowsIndexRoute: typeof AuthenticatedSlideshowsIndexRoute;
  AuthenticatedTickersIndexRoute: typeof AuthenticatedTickersIndexRoute;
  AuthenticatedUserSettingsIndexRoute: typeof AuthenticatedUserSettingsIndexRoute;
  AuthenticatedExternalContentEmbedsIdRouteRoute: typeof AuthenticatedExternalContentEmbedsIdRouteRouteWithChildren;
  AuthenticatedExternalContentLinksIdRouteRoute: typeof AuthenticatedExternalContentLinksIdRouteRouteWithChildren;
  AuthenticatedExternalContentVideosIdRouteRoute: typeof AuthenticatedExternalContentVideosIdRouteRouteWithChildren;
  AuthenticatedExternalContentEmbedsNewRoute: typeof AuthenticatedExternalContentEmbedsNewRoute;
  AuthenticatedExternalContentLinksNewRoute: typeof AuthenticatedExternalContentLinksNewRoute;
  AuthenticatedExternalContentVideosNewRoute: typeof AuthenticatedExternalContentVideosNewRoute;
  AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125Route: typeof AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125Route;
  AuthenticatedExternalContentEmbedsIndexRoute: typeof AuthenticatedExternalContentEmbedsIndexRoute;
  AuthenticatedExternalContentLinksIndexRoute: typeof AuthenticatedExternalContentLinksIndexRoute;
  AuthenticatedExternalContentVideosIndexRoute: typeof AuthenticatedExternalContentVideosIndexRoute;
  AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125Route: typeof AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125Route;
  AuthenticatedPreviewPlacementSectionIdTenantIdRoute: typeof AuthenticatedPreviewPlacementSectionIdTenantIdRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCategoriesRouteRoute:
    AuthenticatedCategoriesRouteRouteWithChildren,
  AuthenticatedCollectionsRouteRoute:
    AuthenticatedCollectionsRouteRouteWithChildren,
  AuthenticatedGeneeaEntitiesRouteRoute:
    AuthenticatedGeneeaEntitiesRouteRouteWithChildren,
  AuthenticatedKickwordsRouteRoute:
    AuthenticatedKickwordsRouteRouteWithChildren,
  AuthenticatedNewslettersRouteRoute:
    AuthenticatedNewslettersRouteRouteWithChildren,
  AuthenticatedPlacementRouteRoute:
    AuthenticatedPlacementRouteRouteWithChildren,
  AuthenticatedReleasenotesRouteRoute:
    AuthenticatedReleasenotesRouteRouteWithChildren,
  AuthenticatedRtelementsRouteRoute:
    AuthenticatedRtelementsRouteRouteWithChildren,
  AuthenticatedSitemapsRouteRoute: AuthenticatedSitemapsRouteRouteWithChildren,
  AuthenticatedTagsRouteRoute: AuthenticatedTagsRouteRouteWithChildren,
  AuthenticatedTeamsRouteRoute: AuthenticatedTeamsRouteRouteWithChildren,
  AuthenticatedUsersRouteRoute: AuthenticatedUsersRouteRouteWithChildren,
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedArticlesIdRouteRoute:
    AuthenticatedArticlesIdRouteRouteWithChildren,
  AuthenticatedBreakingnewsIdRouteRoute:
    AuthenticatedBreakingnewsIdRouteRouteWithChildren,
  AuthenticatedSlideshowsIdRouteRoute:
    AuthenticatedSlideshowsIdRouteRouteWithChildren,
  AuthenticatedTickersIdRouteRoute:
    AuthenticatedTickersIdRouteRouteWithChildren,
  AuthenticatedArticlesNewRoute: AuthenticatedArticlesNewRoute,
  AuthenticatedBreakingnewsNewRoute: AuthenticatedBreakingnewsNewRoute,
  AuthenticatedMaintenancenotesIdRoute: AuthenticatedMaintenancenotesIdRoute,
  AuthenticatedSlideshowsNewRoute: AuthenticatedSlideshowsNewRoute,
  AuthenticatedTickersNewRoute: AuthenticatedTickersNewRoute,
  AuthenticatedhomeIndexRoute: AuthenticatedhomeIndexRoute,
  AuthenticatedArticlesIndexRoute: AuthenticatedArticlesIndexRoute,
  AuthenticatedBreakingnewsIndexRoute: AuthenticatedBreakingnewsIndexRoute,
  AuthenticatedCuratedListIndexRoute: AuthenticatedCuratedListIndexRoute,
  AuthenticatedPlateIndexRoute: AuthenticatedPlateIndexRoute,
  AuthenticatedSlideshowsIndexRoute: AuthenticatedSlideshowsIndexRoute,
  AuthenticatedTickersIndexRoute: AuthenticatedTickersIndexRoute,
  AuthenticatedUserSettingsIndexRoute: AuthenticatedUserSettingsIndexRoute,
  AuthenticatedExternalContentEmbedsIdRouteRoute:
    AuthenticatedExternalContentEmbedsIdRouteRouteWithChildren,
  AuthenticatedExternalContentLinksIdRouteRoute:
    AuthenticatedExternalContentLinksIdRouteRouteWithChildren,
  AuthenticatedExternalContentVideosIdRouteRoute:
    AuthenticatedExternalContentVideosIdRouteRouteWithChildren,
  AuthenticatedExternalContentEmbedsNewRoute:
    AuthenticatedExternalContentEmbedsNewRoute,
  AuthenticatedExternalContentLinksNewRoute:
    AuthenticatedExternalContentLinksNewRoute,
  AuthenticatedExternalContentVideosNewRoute:
    AuthenticatedExternalContentVideosNewRoute,
  AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125Route:
    AuthenticatedIsolatedChar123ScenarioNameChar125Char123PresetChar125Route,
  AuthenticatedExternalContentEmbedsIndexRoute:
    AuthenticatedExternalContentEmbedsIndexRoute,
  AuthenticatedExternalContentLinksIndexRoute:
    AuthenticatedExternalContentLinksIndexRoute,
  AuthenticatedExternalContentVideosIndexRoute:
    AuthenticatedExternalContentVideosIndexRoute,
  AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125Route:
    AuthenticatedPreviewMetadataMetadataIdChar123TenantIdChar125Route,
  AuthenticatedPreviewPlacementSectionIdTenantIdRoute:
    AuthenticatedPreviewPlacementSectionIdTenantIdRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  R401Route: R401Route,
  R403Route: R403Route,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
